<template>
  <div id="sovdetail">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap">
  		<div class="leftcontent wrapitem">
  			<div class="datebox">
  	 			<datepicker placeholder="From" @input="changeCustomDate" v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<option value="https://www.amazon.com">Amazon</option>
          </select>
        </div>
        <div  class="datebox" style="width:18%">
          <select @change="refresh" v-model="catType" class="form-control text-uppercase">
            <option value="mayonnaise">mayonnaise</option>
            <option value="peanut butter">peanut butter</option>
          </select>
        </div>
  	 		<div class="datebox">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
       <div class="righcontent wrapitem">
        	<div class="datebox" style="float:right">
          <button @click="backToSov" style="width:max-content;float:right" class="btn btn-block weavrpurple" type="button">
            <i class="fa fa-arrow-left"></i>
            <span style="font-size:13px"> Back</span>
          </button>
        </div>
      </div>
  	</div>
    <div class="container-fluid ">
      <div class="">
        <div class="card p-2">
          <div class="amd-legend"> 
          
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffb9b9!important"></i>
              <span>{{ p1 }}</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #c7e0ff!important"></i>
              <span>{{ p2 }}</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #ffd0f5 !important"></i>
              <span>{{ p3 }}</span>
            </div>  
            <div class="legending">
              <i class="fa fa-circle" style="color: #edf2fb!important"></i>
              <span>{{ p4 }}</span>
            </div>
          </div>  
          <table id="myTable2" class="table table-striped table-bordered">
            <thead class="thead-normal">
              <tr>
                <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group;">
                <tr>
                  <th v-for="d in columns_details" :key="d.field"> {{ d.label  }} </th>
                </tr>
              </tfoot> 
            <tbody class="tbody-normal" > 
              <tr v-for="(r,i) in rows_details"  :key="i" :class="{'markitamd':r['brand'] == p1,
                'markitintel':r['brand'] == p2,'markitsnap':r['brand'] == p3,'markitna':r['brand'] == p4}">
                <td v-for="d in columns_details" :key="d.field" > 
                  <span v-if="d.field == 'product_name'">
                    <a target="_blank" :href="r['link']">{{r[d.field]}}</a>
                  </span>
                  <span v-else>
                    <span v-if="r[d.field] != ''">
                      <span>{{r[d.field]}}</span>
                    </span>
                    <span v-else>-</span>  
                  </span>
                </td>
              </tr>
            </tbody>
          </table> 
        </div>   
      </div>  
    </div>  
    <b-modal size="lg" title="Audit" v-model="showAuditModal" >
      <table id="sku" class="table table-bordered">
        <thead class="thead-normal">
          <tr>
            <th v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
               {{ d.label  }} 
              <span  v-if="d.field == 'compliance_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(((Product Logo + OEM Images + Nomenclature + Message)/4)/3)*100">?</b-btn> 
              </span>   
              <span  v-if="d.field == 'position_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(100 - Category Position) 
                  if Category Position < 100,
                  0 if Category Position > 100">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'sku_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Compliance Score + Position Score + Rating Score)/3">?</b-btn> 
              </span>  
              <span  v-if="d.field == 'rating_score'">
                 <b-btn class="hint" v-b-tooltip.hover title="(Rating/5)*100">?</b-btn> 
              </span>  
            </th>
          </tr>
        </thead>
        <tbody class="tbody-normal" > 
          <tr v-for="(r,i) in rowsAudit" :key="i">
            <td v-for="d in columnsAudit" :key="d.field" style="border:1px solid silver!important"> 
              {{r[d.field]}} 
            </td>
          </tr>
        </tbody>
      </table>   
      <h5 class="cust-head">Position Score</h5>
      <table id="position" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }}
            <span  v-if="d.field == 'category_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position In Category Page">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'category_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of results
                  2: if System in page 2-3 of results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_position'">
                <b-btn class="hint" v-b-tooltip.hover title="Position in on-site search">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'search_13_position'">
                <b-btn class="hint" v-b-tooltip.hover title="1: If System in page 1 of search results
                  2: if System in page 2-3 of search results
                  3: if System not in pages 1-3 ">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_category" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 

      <h5 class="cust-head">Compliance Score</h5>
      <table id="compliance" class="table table-bordered">
      <thead class="thead-normal">
        <tr>
          <th v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            {{ d.label  }} 
            <span  v-if="d.field == 'logo'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Badges
                  2: Incorrect AMD Badges
                  3: No AMD Badges">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'image_count'">
                <b-btn class="hint" v-b-tooltip.hover title="1: 3 or more product images
                  2: 2 more product images
                  3: 0 or 1 product images">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'nomenclature'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Nomenclature
                  2: Incorrect AMD Nomenclature
                  3: No AMD Nomenclature">?</b-btn> 
            </span> 
            <span  v-if="d.field == 'message'">
                <b-btn class="hint" v-b-tooltip.hover title="1: Correct AMD Messaging
                  2: Incorrect AMD Messaging
                  3: No AMD Messaging">?</b-btn> 
            </span> 
          </th>
        </tr>
      </thead>
      <tbody class="tbody-normal" > 
        <tr v-for="(r,i) in rowsAudit" :key="i">
          <td v-for="d in columns_compliance" :key="d.field" style="border:1px solid silver!important"> 
            <span> {{r[d.field]}} </span>
          </td>
        </tr>
      </tbody>
      </table> 
    </b-modal>
  </div>
</template>
<script>  

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'sovdetail',
  components: { Datepicker},
  data: function () {
    return {
    	selected_website:localStorage.selected_website,
      date:{
        startDate: moment().subtract(1,'days').format('YYYY-MM-DD')
      },
      columns_details:[
        {label: 'Rank', field: 'order'},
        {label: 'Page', field: 'page'},
        {label: 'Brand', field: 'brand'},
        {label: 'Name', field: 'product_name',sortable: false},
        {label: 'Price', field: 'price',sortable: false},
        {label: 'Offer', field: 'offer',sortable: false},
        {label: 'Reviews', field: 'reviews'},
        {label: 'Ratings', field: 'ratings'}
      ],
      rows:[],
      rows_details:[],
      page:1,   
      showAuditModal: false,
      columnsAudit:[
        {label: 'SKU', field: 'sku', sortable: false},
        {label: 'Compliance Score', field:'compliance_score', sortable: false},
        {label: 'Position Score', field: 'position_score', sortable: false},
        {label: 'Rating Score', field: 'rating_score', sortable: false},
        {label: 'SKU Score', field: 'sku_score', sortable: false},
      ],
      columns_category:[
        {label: 'Category Position', field: 'category_position',sortable: false},
        {label: 'Category page position (1-3)', field: 'category_13_position',sortable: false},
        {label: 'Search Position', field: 'search_position',sortable: false},
        {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false}
      ],
      columns_compliance:[
        {label: 'Product Logo', field: 'logo',sortable: false},
        {label: 'OEM Images', field: 'image_count',sortable: false},
        {label: 'Nomenclature', field: 'nomenclature',sortable: false},
        {label: 'Message', field: 'message',sortable: false}
      ],
      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      catType: 'peanut butter',
      p1: 'funfoods',
      p2: 'del monte',
      p3: 'wingreens farms',
      p4: 'veeba'
    }
  },
  mounted()
  {
    let self = this
    self.p1 = 'funfoods'
    self.p2 = 'del monte'
    self.p3 = 'wingreens farms'
    self.p4 = 'veeba'
    if (self.catType != 'mayonnaise')
    {
      self.p1 = 'funfoods'
      self.p2 = 'pintola'
      self.p3 = 'alpino'
      self.p4 = 'muscleblaze'
    }
    this.website_details()
  },
  methods: {
    backToSov()
    { 
      window.location = '#/sov-summary-funfoods'

    },
    showHeroChange(){
      let self = this
      $('#myTable2').DataTable().destroy();
      this.rows_details = []
      for(let [idx, dataset] of this.rows_details_full.entries()) 
      {
        if(self.isHero)
        {
          if(dataset.is_hero)
          {
            this.rows_details.push(dataset)
          }  
        }  
        else
          this.rows_details.push(dataset)
      }
      this.$nextTick(function(){
        self.initDt2()
      })  
    },
   
    openAuditModal(r){
      let self = this
      self.rowsAudit = []
      self.showAuditModal = true
      self.rowsAudit.push(r.audit)
    },
    
    format(v)
    {
      return this.$options.filters.format(v)
    },
    refresh(){
      let self = this
      $('#myTable2').DataTable().destroy();
      localStorage.selected_website = this.selected_website
      self.p1 = 'funfoods'
      self.p2 = 'del monte'
      self.p3 = 'wingreens farms'
      self.p4 = 'veeba'
      if (self.catType != 'mayonnaise')
      {
        self.p1 = 'funfoods'
        self.p2 = 'pintola'
        self.p3 = 'alpino'
        self.p4 = 'muscleblaze'
      }
      this.website_details()
    },
  
    website_details(){
      let self = this
      self.loader = true
      this.rows_details = []
      this.rows_details_full = []
      const url = "/api/websites/details"
      this.$http.post(url, { "website": this.selected_website,"timestamp":this.date.startDate }).then(response => {
        let resData = [ {
            "order": 1,
            "price": "",
            "offer": "Rs 165.00",
            "page": 1,
            "link": "https//www.amazon.in//Del-Monte-Eggless-Mayo-900g/dp/B00RTC02IW/",
            "page_count": 48,
            "reviews": 844,
            "ratings": 4.4,
            "image_count": 7,
            "product_name": "Del Monte Eggless Mayonnaise, 900g",
            "item_id": "B00RTC02IW",
            "brand": "del monte"
          },
          {
            "order": 2,
            "price": "",
            "offer": "Rs 180.00",
            "page": 1,
            "link": "https//www.amazon.in//Del-Monte-Eggless-Mayonnaise-900g/dp/B082DG1V1S/",
            "page_count": 48,
            "reviews": 259,
            "ratings": 4.4,
            "image_count": 5,
            "product_name": "Del Monte Eggless Mayonnaise, 900g",
            "item_id": "B082DG1V1S",
            "brand": "del monte"
          },
          {
            "order": 3,
            "price": "Rs 175.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Mayo-Pack-100g-Each/dp/B01CSFWXNQ/",
            "page_count": 48,
            "reviews": 400,
            "ratings": 4.4,
            "image_count": 6,
            "product_name": "Dr. OETKER FUN FOODS Veg Mayo (875 g)",
            "item_id": "B01CSFWXNQ",
            "brand": "dr. oetker fun foods"
          },
          {
            "order": 4,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Burger-Mayonnaise-Eggless-275g/dp/B00RT36CSA/",
            "page_count": 48,
            "reviews": 20,
            "ratings": 4.4,
            "image_count": 4,
            "product_name": "Funfoods Burger Mayonnaise Eggless, 250g",
            "item_id": "B00RT36CSA",
            "brand": "funfoods"
          },
          {
            "order": 5,
            "price": "Rs 99.00",
            "offer": "Rs 119.00",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Veg-Mayo-500g/dp/B01GCE7L9K/",
            "page_count": 48,
            "reviews": 164,
            "ratings": 4.4,
            "image_count": 1,
            "product_name": "Funfoods Veg Mayonnaise, Eggless, 500g",
            "item_id": "B01GCE7L9K",
            "brand": "funfoods"
          },
          {
            "order": 6,
            "price": "Rs 135.00",
            "offer": "Rs 169.00",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-Pouch-875g/dp/B079QT2K4M/",
            "page_count": 48,
            "reviews": 40,
            "ratings": 4.2,
            "image_count": 4,
            "product_name": "Veeba Eggless Mayonnaise Chef's Special, 875g",
            "item_id": "B079QT2K4M",
            "brand": "veeba"
          },
          {
            "order": 7,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Burger-Mayonnaise-280g/dp/B071ZLL7T9/",
            "page_count": 48,
            "reviews": 17,
            "ratings": 4.3,
            "image_count": 7,
            "product_name": "Veeba Burger Mayonnaise, 250g",
            "item_id": "B071ZLL7T9",
            "brand": "veeba"
          },
          {
            "order": 8,
            "price": "",
            "offer": "Rs 207.00",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Mayonnaise-Combo-Eggless-Garlic/dp/B08BVMNLBH/",
            "page_count": 48,
            "reviews": 21,
            "ratings": 4.1,
            "image_count": 4,
            "product_name": "Veeba Mayonnaise Combo - Eggless Mayonnaise, 250gm with Garlic Mayonnaise, 250gm and Burger Mayonnaise 250gm - Pack of 3",
            "item_id": "B08BVMNLBH",
            "brand": "veeba"
          },
          {
            "order": 9,
            "price": "Rs 65.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-275g/dp/B072C8CCTL/",
            "page_count": 48,
            "reviews": 5,
            "ratings": 4.4,
            "image_count": 6,
            "product_name": "Veeba Eggless Mayonnaise, 250g",
            "item_id": "B072C8CCTL",
            "brand": "veeba"
          },
          {
            "order": 10,
            "price": "Rs 271.00",
            "offer": "Rs 338.00",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-Chefs-Special/dp/B08J7S1HLT/",
            "page_count": 48,
            "reviews": 5,
            "ratings": 3.7,
            "image_count": 5,
            "product_name": "Veeba Eggless Mayonnaise Chef's Special, 875g - Pack of 2",
            "item_id": "B08J7S1HLT",
            "brand": "veeba"
          },
          {
            "order": 11,
            "price": "Rs 34.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-Pouch-100g/dp/B07997SMMV/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.1,
            "image_count": 4,
            "product_name": "Veeba Eggless Mayonnaise Pouch, 100g",
            "item_id": "B07997SMMV",
            "brand": "veeba"
          },
          {
            "order": 12,
            "price": "",
            "offer": "Rs 165.00",
            "page": 1,
            "link": "https//www.amazon.in//Solimo-Eggless-Mayo-900-g/dp/B07N4GTXSS/",
            "page_count": 48,
            "reviews": 73,
            "ratings": 4.3,
            "image_count": 3,
            "product_name": "Amazon Brand - Solimo Eggless Mayonnaise, 900g",
            "item_id": "B07N4GTXSS",
            "brand": "amazon brand - solimo"
          },
          {
            "order": 13,
            "price": "",
            "offer": "Rs 218.00",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Mint-Mayonnaise-300g-Tandoori/dp/B08BVLPK39/",
            "page_count": 48,
            "reviews": 24,
            "ratings": 4.2,
            "image_count": 3,
            "product_name": "Veeba Mint Mayonnaise, 300g and Tandoori Mayonnaise, 250g - Pack of 2",
            "item_id": "B08BVLPK39",
            "brand": "veeba"
          },
          {
            "order": 14,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Classic-Mayonnaise-270g/dp/B01CHV1FLW/",
            "page_count": 48,
            "reviews": 34,
            "ratings": 4.1,
            "image_count": 4,
            "product_name": "Dr Oetker Funfoods Mayo Classic 245g",
            "item_id": "B01CHV1FLW",
            "brand": "funfoods"
          },
          {
            "order": 15,
            "price": "Rs 149.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Mint-Mayonnaise-300g/dp/B072KLBT76/",
            "page_count": 48,
            "reviews": 42,
            "ratings": 4.3,
            "image_count": 5,
            "product_name": "Veeba Mint Mayonnaise, 300g",
            "item_id": "B072KLBT76",
            "brand": "veeba"
          },
          {
            "order": 16,
            "price": "Rs 499.00",
            "offer": "Rs 750.00",
            "page": 1,
            "link": "https//www.amazon.in//Hellmanns-5000184321064-Real-Mayonnaise-400g/dp/B007XR37HG/",
            "page_count": 48,
            "reviews": 20,
            "ratings": 4,
            "image_count": 2,
            "product_name": "Hellmann's Real Mayonnaise, 400g",
            "item_id": "B007XR37HG",
            "brand": "hellmann's"
          },
          {
            "order": 17,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Season-Special-Mayonnaise-275g/dp/B00RT36JD8/",
            "page_count": 48,
            "reviews": 9,
            "ratings": 3.7,
            "image_count": 1,
            "product_name": "Dr.Oetker Funfoods Veg Mayonnaise - Tandoori, 245g",
            "item_id": "B00RT36JD8",
            "brand": "funfoods"
          },
          {
            "order": 18,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Classic-Mayonnaise-275g/dp/B071J7CN81/",
            "page_count": 48,
            "reviews": 11,
            "ratings": 4.1,
            "image_count": 3,
            "product_name": "Veeba Classic Mayonnaise, 250g",
            "item_id": "B071J7CN81",
            "brand": "veeba"
          },
          {
            "order": 19,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Garlic-Mayonnaise-280g/dp/B071GRS8WW/",
            "page_count": 48,
            "reviews": 56,
            "ratings": 4.4,
            "image_count": 2,
            "product_name": "Veeba Garlic Mayonnaise, 250g",
            "item_id": "B071GRS8WW",
            "brand": "veeba"
          },
          {
            "order": 20,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Garlic-Mayonnaise-Eggless-275g/dp/B00RT36730/",
            "page_count": 48,
            "reviews": 10,
            "ratings": 4.2,
            "image_count": 1,
            "product_name": "Funfoods Garlic Veg Mayonnaise Eggless, 250g",
            "item_id": "B00RT36730",
            "brand": "funfoods"
          },
          {
            "order": 21,
            "price": "Rs 149.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Wingreens-Farms-Veg-Mayo-450g/dp/B07C5R8G3C/",
            "page_count": 48,
            "reviews": 94,
            "ratings": 4.2,
            "image_count": 4,
            "product_name": "Wingreens Farms- Premium Veg Mayo (Pack of 1-450g)",
            "item_id": "B07C5R8G3C",
            "brand": "wingreens farms"
          },
          {
            "order": 22,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Garlic-Mayonnaise-275g/dp/B01GCE6UZ6/",
            "page_count": 48,
            "reviews": 40,
            "ratings": 4.3,
            "image_count": 1,
            "product_name": "Funfoods Garlic Mayonnaise Eggless, 250g",
            "item_id": "B01GCE6UZ6",
            "brand": "funfoods"
          },
          {
            "order": 23,
            "price": "Rs 101.00",
            "offer": "\nRs 119.00",
            "page": 1,
            "link": "https//www.amazon.in//Wingreens-Farms-Italian-Herb-Mayo/dp/B07VNQV8M5/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 5,
            "image_count": 4,
            "product_name": "Wingreens Farms Italian Herb Mayo, 130 g",
            "item_id": "B07VNQV8M5",
            "brand": "wingreens farms"
          },
          {
            "order": 24,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Smart-Mayonnaise-275g/dp/B072JFR2XG/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 4.6,
            "image_count": 3,
            "product_name": "Veeba Smart Mayonnaise, 250g",
            "item_id": "B072JFR2XG",
            "brand": "veeba"
          },
          {
            "order": 25,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Tandoori-Mayonnaise-275-GMS/dp/B083DPQ8FH/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.5,
            "image_count": 6,
            "product_name": "Veeba - Tandoori Mayonnaise 275 GMS, Jar",
            "item_id": "B083DPQ8FH",
            "brand": "veeba"
          },
          {
            "order": 26,
            "price": "Rs 193.00",
            "offer": "Rs 350.00",
            "page": 1,
            "link": "https//www.amazon.in//GURU-KRIPA-EGGLESS-Mayonnaise-THARMACOOL/dp/B08CGFW5G7/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 5,
            "image_count": 7,
            "product_name": "GURU KRIPA VEEBA EGGLESS Mayonnaise 1 KG Pack Plastic Box and THARMACOOL Box",
            "item_id": "B08CGFW5G7",
            "brand": "guru kripa"
          },
          {
            "order": 27,
            "price": "Rs 499.00",
            "offer": "Rs 799.00",
            "page": 1,
            "link": "https//www.amazon.in//Hellmanns-29574-Real-Mayonnaise-430ml/dp/B003VFJFCK/",
            "page_count": 48,
            "reviews": 19,
            "ratings": 4.3,
            "image_count": 1,
            "product_name": "Hellmann's Real Mayonnaise, 430 ml",
            "item_id": "B003VFJFCK",
            "brand": "hellmann's"
          },
          {
            "order": 28,
            "price": "Rs 199.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Wingreens-Farms-Italian-Herb-Mayo/dp/B07C63323L/",
            "page_count": 48,
            "reviews": 135,
            "ratings": 4.2,
            "image_count": 4,
            "product_name": "Wingreens Farms- Italian Herb Mayo (Pack of 1-450g)",
            "item_id": "B07C63323L",
            "brand": "wingreens farms"
          },
          {
            "order": 29,
            "price": "Rs 399.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Kewpie-Mayonnaise-Japanese-Style-310ml/dp/B08QZ46MMN/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "Kewpie Mayonnaise Japanese Style 310ml Imported",
            "item_id": "B08QZ46MMN",
            "brand": "kewpie"
          },
          {
            "order": 30,
            "price": "Rs 199.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Wingreens-Farms-Premium-Mayo-800g/dp/B083ZTBV5Q/",
            "page_count": 48,
            "reviews": 26,
            "ratings": 4.4,
            "image_count": 3,
            "product_name": "Wingreens Farms Premium Veg Mayo, 800g",
            "item_id": "B083ZTBV5Q",
            "brand": "wingreens farms"
          },
          {
            "order": 31,
            "price": "Rs 504.00",
            "offer": "Rs 799.00",
            "page": 1,
            "link": "https//www.amazon.in//Hellmanns-Mayonnaise-Squeeze-Real-430ml/dp/B07339L84J/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 1,
            "product_name": "Hellmann's Mayonnaise Squeeze, Real, 430ml",
            "item_id": "B07339L84J",
            "brand": "hellmann's"
          },
          {
            "order": 32,
            "price": "",
            "offer": "Rs 290.00",
            "page": 1,
            "link": "https//www.amazon.in//Nandos-Perinaise-Mayonnaise-Product-Netherlands/dp/B08RDPXPHV/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 3,
            "product_name": "Nando's Perinaise Mayonnaise, Garlic, 265g, Product of The Netherlands",
            "item_id": "B08RDPXPHV",
            "brand": "nando's"
          },
          {
            "order": 33,
            "price": "",
            "offer": "Rs 290.00",
            "page": 1,
            "link": "https//www.amazon.in//Nandos-Perinaise-Peri-Peri-Mild-Mayonnaise/dp/B06X6FCKLC/",
            "page_count": 48,
            "reviews": 5,
            "ratings": 4.3,
            "image_count": 1,
            "product_name": "Nando's Perinaise Mayonnaise, Mild, 265g, Product of The Netherlands",
            "item_id": "B06X6FCKLC",
            "brand": "nando's"
          },
          {
            "order": 34,
            "price": "Rs 69.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Dr-Oetker-Funfoods-Mayo-Original/dp/B08CVPRYZX/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 4.4,
            "image_count": 6,
            "product_name": "Dr. Oetker Funfoods Dr. Oetker Mayo Veg Original, 250g",
            "item_id": "B08CVPRYZX",
            "brand": "dr. oetker"
          },
          {
            "order": 35,
            "price": "",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Funfoods-Veg-Mayonnaise-Original-875g/dp/B08HLS56R2/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 5,
            "image_count": 6,
            "product_name": "Funfoods Veg Mayonnaise - Original, 875g",
            "item_id": "B08HLS56R2",
            "brand": "funfoods"
          },
          {
            "order": 36,
            "price": "Rs 138.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-Tandoori-Mayonnaise-275gm-Pack/dp/B07LG2S3XM/",
            "page_count": 48,
            "reviews": 8,
            "ratings": 4.3,
            "image_count": 1,
            "product_name": "Veeba Tandoori Mayonnaise 275gm - Pack of 2",
            "item_id": "B07LG2S3XM",
            "brand": "veeba"
          },
          {
            "order": 37,
            "price": "Rs 119.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Wingreens-Farms-Garlic-Mayonnaise-Aioli/dp/B07CQ4MTMC/",
            "page_count": 48,
            "reviews": 24,
            "ratings": 3.9,
            "image_count": 2,
            "product_name": "Wingreens Farms- Garlic Mayonnaise (Aioli) (Pack of 1)",
            "item_id": "B07CQ4MTMC",
            "brand": "wingreens farms"
          },
          {
            "order": 38,
            "price": "",
            "offer": "Rs 207.00",
            "page": 1,
            "link": "https//www.amazon.in//Veeba-American-Mustard-Eggless-Mayonnaise/dp/B08BVMD5Z1/",
            "page_count": 48,
            "reviews": 8,
            "ratings": 4,
            "image_count": 3,
            "product_name": "Veeba American Mustard Sauce,300g and Eggless Mayonnaise,250g - Pack of 2",
            "item_id": "B08BVMD5Z1",
            "brand": "veeba"
          },
          {
            "order": 39,
            "price": "Rs 35.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Dr-Oetker-Funfoods-Veg-Mayonnaise/dp/B08BM9J3MK/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 1,
            "product_name": "Dr Oetker Funfoods Veg Mayonnaise - Garlic 100g Chotu Pack",
            "item_id": "B08BM9J3MK",
            "brand": "dr oetker funfoods"
          },
          {
            "order": 40,
            "price": "Rs 440.00",
            "offer": "Rs 1,200.00",
            "page": 1,
            "link": "https//www.amazon.in//Hellmanns-Light-Squeezy-Mayonnaise-430ml/dp/B005HN566S/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.1,
            "image_count": 5,
            "product_name": "Hellmann's Light Mayonnaise, 430 ml",
            "item_id": "B005HN566S",
            "brand": "hellmann's"
          },
          {
            "order": 41,
            "price": "Rs 340.00",
            "offer": "Rs 350.00",
            "page": 1,
            "link": "https//www.amazon.in//Urban-Platter-Dairy-Free-Mayonnaise-Trans-Fat/dp/B07L8YXD43/",
            "page_count": 48,
            "reviews": 19,
            "ratings": 4.1,
            "image_count": 7,
            "product_name": "Urban Platter Vegan Premium Mayo, 300g / 10.6oz [Dairy-Free Mayonnaise, No Palm Oil, No Trans-Fat]",
            "item_id": "B07L8YXD43",
            "brand": "urban platter"
          },
          {
            "order": 42,
            "price": "Rs 200.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//ENE-Jolokia-Chilli-Mayonnaise-190gm/dp/B089Q2SHX1/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 3.3,
            "image_count": 7,
            "product_name": "ENE Bhut Jolokia Chilli Mayonnaise, 190gm",
            "item_id": "B089Q2SHX1",
            "brand": "ene"
          },
          {
            "order": 43,
            "price": "Rs 299.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Sprig-Chimichurri-Aioli-Sauce-260g/dp/B085W42YG1/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "SPRIG CHIMICHURRI AIOLI | Delicious eggless dip | Better Than Mayonnaise | Twist of Chimichurri – Fresh Coriander, Jalapeno and Lime | 260g",
            "item_id": "B085W42YG1",
            "brand": "s p r i g"
          },
          {
            "order": 44,
            "price": "Rs 300.00",
            "offer": "Rs 340.00",
            "page": 1,
            "link": "https//www.amazon.in//American-Garden-Mayonnaise-Eggless-473ml/dp/B00L28CLEW/",
            "page_count": 48,
            "reviews": 38,
            "ratings": 3.8,
            "image_count": 6,
            "product_name": "American Garden Mayonnaise Eggless, 460 g",
            "item_id": "B00L28CLEW",
            "brand": "american garden"
          },
          {
            "order": 45,
            "price": "Rs 299.00",
            "offer": "",
            "page": 1,
            "link": "https//www.amazon.in//Chipotle-Delicious-eggless-Mayonnaise-Chillies/dp/B08MKLK7H5/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.5,
            "image_count": 6,
            "product_name": "SPRIG Smoky Chipotle AIOLI | Delicious eggless dip | Better Than Mayonnaise | Twist of Mexican Smoky Chipotle Chillies | 260g",
            "item_id": "B08MKLK7H5",
            "brand": "sprig"
          },
          {
            "order": 46,
            "price": "Rs 275.00",
            "offer": "Rs 280.00",
            "page": 1,
            "link": "https//www.amazon.in//NOTTACIA-Remia-Delicious-Creamy-Mayonnaise/dp/B08NPRCYGT/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "NOTTACIA Remia Delicious and Creamy Mayonnaise (500 g)",
            "item_id": "B08NPRCYGT",
            "brand": "nottacia"
          },
          {
            "order": 47,
            "price": "Rs 101.00",
            "offer": "\nRs 119.00",
            "page": 1,
            "link": "https//www.amazon.in//Wingreens-Farms-Wasabi-Mayo-130/dp/B07VSXPZ9B/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.6,
            "image_count": 4,
            "product_name": "Wingreens Farms Wasabi Mayo, 130 g",
            "item_id": "B07VSXPZ9B",
            "brand": "wingreens farms"
          },
          {
            "order": 48,
            "price": "Rs 289.00",
            "offer": "Rs 290.00",
            "page": 1,
            "link": "https//www.amazon.in//Nandos-Perinaise-Peri-Mayonnaise-Hot/dp/B07MRH6599/",
            "page_count": 48,
            "reviews": 15,
            "ratings": 4.2,
            "image_count": 2,
            "product_name": "Nando's Perinaise Peri Peri Mayonnaise Hot (265 Gm)",
            "item_id": "B07MRH6599",
            "brand": "nando's"
          },
          {
            "order": 49,
            "price": "Rs 289.00",
            "offer": "Rs 290.00",
            "page": 2,
            "link": "https//www.amazon.in//Nandos-Perinaise-Peri-Mayonnaise-Hot/dp/B07MRH6599/",
            "page_count": 48,
            "reviews": 15,
            "ratings": 4.2,
            "image_count": 2,
            "product_name": "Nando's Perinaise Peri Peri Mayonnaise Hot (265 Gm)",
            "item_id": "B07MRH6599",
            "brand": "nando's"
          },
          {
            "order": 50,
            "price": "Rs 429.00",
            "offer": "Rs 450.00",
            "page": 2,
            "link": "https//www.amazon.in//American-Garden-U-S-Mayonnaise-887ml/dp/B00L28C8KY/",
            "page_count": 48,
            "reviews": 56,
            "ratings": 4,
            "image_count": 6,
            "product_name": "American Garden U.S. Mayonnaise, 887ml",
            "item_id": "B00L28C8KY",
            "brand": "american garden"
          },
          {
            "order": 51,
            "price": "Rs 299.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wasabi-Delicious-eggless-Mayonnaise-Japanese/dp/B08MLDNPPY/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "SPRIG Wasabi AIOLI | Delicious eggless dip | Better Than Mayonnaise | Twist of Japanese Wasabi | 260g",
            "item_id": "B08MLDNPPY",
            "brand": "sprig"
          },
          {
            "order": 52,
            "price": "Rs 35.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Dr-Oetker-Funfoods-Veg-Mayonnaise/dp/B08CRPZJHZ/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 4.1,
            "image_count": 6,
            "product_name": "Dr Oetker Funfoods Veg Mayonnaise - Original, 100g Pouch",
            "item_id": "B08CRPZJHZ",
            "brand": "dr oetker funfoods"
          },
          {
            "order": 53,
            "price": "Rs 135.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-Professional-1kg/dp/B084G6G7JX/",
            "page_count": 48,
            "reviews": 3,
            "ratings": 3.1,
            "image_count": 4,
            "product_name": "Veeba Eggless Mayonnaise (Professional) 1kg",
            "item_id": "B084G6G7JX",
            "brand": "veeba"
          },
          {
            "order": 54,
            "price": "Rs 99.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Achaari-Mayonnaise-Sauce/dp/B074ZLZ19Y/",
            "page_count": 48,
            "reviews": 17,
            "ratings": 4.4,
            "image_count": 4,
            "product_name": "Wingreens Farms Achaari Mayonnaise Sauce (Pack of 1)",
            "item_id": "B074ZLZ19Y",
            "brand": "wingreens farms"
          },
          {
            "order": 55,
            "price": "",
            "offer": "Rs 84.00",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Chilli-Mayonnaise-275g/dp/B072PZBR35/",
            "page_count": 48,
            "reviews": 8,
            "ratings": 4.5,
            "image_count": 1,
            "product_name": "Veeba Chilli Mayonnaise, 275g",
            "item_id": "B072PZBR35",
            "brand": "veeba"
          },
          {
            "order": 56,
            "price": "Rs 519.00",
            "offer": "Rs 795.00",
            "page": 2,
            "link": "https//www.amazon.in//Hellmanns-Lighter-Than-Light-Mayonnaise/dp/B0152SRLQU/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.5,
            "image_count": 1,
            "product_name": "Hellmann's Lighter Than Light Mayonnaise, 430 ml",
            "item_id": "B0152SRLQU",
            "brand": "hellmann's"
          },
          {
            "order": 57,
            "price": "Rs 340.00",
            "offer": "Rs 350.00",
            "page": 2,
            "link": "https//www.amazon.in//Urban-Platter-Dairy-Free-Mayonnaise-Trans-Fat/dp/B07QH781PX/",
            "page_count": 48,
            "reviews": 5,
            "ratings": 3.1,
            "image_count": 7,
            "product_name": "Urban Platter Vegan Italian Herb Mayo, 300g / 10.6oz [Dairy-Free Mayonnaise, No Palm Oil, No Trans-Fat]",
            "item_id": "B07QH781PX",
            "brand": "urban platter"
          },
          {
            "order": 58,
            "price": "Rs 149.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Dressing-Mint-Mayonnaise-Bottle/dp/B01KT7L3SG/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.8,
            "image_count": 4,
            "product_name": "Veeba Dressing - Mint Mayonnaise, 300g Bottle",
            "item_id": "B01KT7L3SG",
            "brand": "veeba"
          },
          {
            "order": 59,
            "price": "Rs 119.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Barbeque-Mayonnaise/dp/B07CPZLBRQ/",
            "page_count": 48,
            "reviews": 13,
            "ratings": 3.2,
            "image_count": 3,
            "product_name": "Wingreens Farms Barbeque Mayonnaise (Pack of 1)",
            "item_id": "B07CPZLBRQ",
            "brand": "wingreens farms"
          },
          {
            "order": 60,
            "price": "Rs 500.00",
            "offer": "Rs 799.00",
            "page": 2,
            "link": "https//www.amazon.in//Kraft-kraft-original-mayonnaise-440g/dp/B01N9BY8W7/",
            "page_count": 48,
            "reviews": 32,
            "ratings": 3.6,
            "image_count": 2,
            "product_name": "kraft Original Mayonnaise 440g",
            "item_id": "B01N9BY8W7",
            "brand": "kraft"
          },
          {
            "order": 61,
            "price": "Rs 249.00",
            "offer": "Rs 499.00",
            "page": 2,
            "link": "https//www.amazon.in//Alfa-Mayonnaise-236-5-ml/dp/B01K25MBQS/",
            "page_count": 48,
            "reviews": 4,
            "ratings": 4.4,
            "image_count": 1,
            "product_name": "Alfa Mayonnaise 236.5 ml",
            "item_id": "B01K25MBQS",
            "brand": "alfa"
          },
          {
            "order": 62,
            "price": "Rs 299.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Cheese-Delicious-eggless-Mayonnaise-Umami-Laden/dp/B08MKXQC1J/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "SPRIG Cheese & Black Pepper AIOLI | Delicious eggless dip |Better Than Mayonnaise | with Umami-Laden Aged Cheese & Fresh Black Pepper | 260g",
            "item_id": "B08MKXQC1J",
            "brand": "sprig"
          },
          {
            "order": 63,
            "price": "Rs 140.00",
            "offer": "Rs 159.00",
            "page": 2,
            "link": "https//www.amazon.in//M-K-ENTERPRISES-Delmonte-Eggless-Mayonnaise/dp/B07VXX9VJP/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 4,
            "image_count": 2,
            "product_name": "M.K. ENTERPRISES Delmonte Eggless Mayonnaise",
            "item_id": "B07VXX9VJP",
            "brand": "m.k. enterprises"
          },
          {
            "order": 64,
            "price": "Rs 340.00",
            "offer": "Rs 350.00",
            "page": 2,
            "link": "https//www.amazon.in//Urban-Platter-Dairy-Free-Mayonnaise-Trans-Fat/dp/B07L8ZM7FW/",
            "page_count": 48,
            "reviews": 10,
            "ratings": 3.7,
            "image_count": 7,
            "product_name": "Urban Platter Vegan Tandoori Mayo, 300g / 10.6oz [Dairy-Free Mayonnaise, No Palm Oil, No Trans-Fat]",
            "item_id": "B07L8ZM7FW",
            "brand": "urban platter"
          },
          {
            "order": 65,
            "price": "",
            "offer": "Rs 149.00",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Olive-Oil-Mayonnaise-300g/dp/B01G0AUCJW/",
            "page_count": 48,
            "reviews": 33,
            "ratings": 4.3,
            "image_count": 3,
            "product_name": "Veeba Olive Oil Mayonnaise, 300g",
            "item_id": "B01G0AUCJW",
            "brand": "veeba"
          },
          {
            "order": 66,
            "price": "Rs 540.00",
            "offer": "Rs 750.00",
            "page": 2,
            "link": "https//www.amazon.in//Hellmanns-Lighter-Light-Mayonnaise-430ml/dp/B01N0V8DAD/",
            "page_count": 48,
            "reviews": 3,
            "ratings": 2.6,
            "image_count": 1,
            "product_name": "Hellmann's Lighter Than Light Mayonnaise, 430ml",
            "item_id": "B01N0V8DAD",
            "brand": "hellmann's"
          },
          {
            "order": 67,
            "price": "",
            "offer": "Rs 149.00",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Mint-Mayonnaise-300g/dp/B07DCPTR8F/",
            "page_count": 48,
            "reviews": 13,
            "ratings": 4.1,
            "image_count": 2,
            "product_name": "Veeba Mint Mayonnaise, 300g",
            "item_id": "B07DCPTR8F",
            "brand": "veeba"
          },
          {
            "order": 68,
            "price": "Rs 69.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Funfoods-Veg-Mayonnaise-Chilli-250g/dp/B08BYWCYFV/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 4.6,
            "image_count": 6,
            "product_name": "Funfoods Veg Mayonnaise Chilli, 250g",
            "item_id": "B08BYWCYFV",
            "brand": "funfoods"
          },
          {
            "order": 69,
            "price": "",
            "offer": "Rs 690.00",
            "page": 2,
            "link": "https//www.amazon.in//HEINZ-Seriously-Good-Light-Mayonnaise/dp/B01H5DDCNG/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 3,
            "product_name": "HEINZ Seriously Good Light Mayonnaise, 490 g",
            "item_id": "B01H5DDCNG",
            "brand": "heinz"
          },
          {
            "order": 70,
            "price": "Rs 119.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Premium-Veg-Mayonnaise/dp/B07CPYZT1N/",
            "page_count": 48,
            "reviews": 19,
            "ratings": 3.9,
            "image_count": 4,
            "product_name": "Wingreens Farms Premium Veg Mayonnaise (Pack of 1)",
            "item_id": "B07CPYZT1N",
            "brand": "wingreens farms"
          },
          {
            "order": 71,
            "price": "Rs 300.00",
            "offer": "Rs 320.00",
            "page": 2,
            "link": "https//www.amazon.in//American-Garden-U-S-Mayonnaise-473ml/dp/B00L28C5U2/",
            "page_count": 48,
            "reviews": 15,
            "ratings": 4.5,
            "image_count": 7,
            "product_name": "American Garden U.S. Mayonnaise, 473ml",
            "item_id": "B00L28C5U2",
            "brand": "american garden"
          },
          {
            "order": 72,
            "price": "Rs 101.00",
            "offer": "\nRs 119.00",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Sriracha-Mayo-130/dp/B07VSXPZ9M/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 4.6,
            "image_count": 4,
            "product_name": "Wingreens Farms Sriracha Mayo, 130 g",
            "item_id": "B07VSXPZ9M",
            "brand": "wingreens farms"
          },
          {
            "order": 73,
            "price": "Rs 119.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Sriracha-Mayonnaise/dp/B07CPYK65P/",
            "page_count": 48,
            "reviews": 26,
            "ratings": 4.3,
            "image_count": 3,
            "product_name": "Wingreens Farms Sriracha Mayonnaise, 130g",
            "item_id": "B07CPYK65P",
            "brand": "wingreens farms"
          },
          {
            "order": 74,
            "price": "Rs 130.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Sams-Mayonnaise-Vegetarian-Homemade-Delicious/dp/B08K3QF5WQ/",
            "page_count": 48,
            "reviews": 4,
            "ratings": 2.8,
            "image_count": 7,
            "product_name": "Sams Egg Mayonnaise 200 Grams Pack of 2 Non Vegetarian Mayo Fresh Farm for Homemade Recipe Delicious Thick Mayonnaise Spreads and Dips",
            "item_id": "B08K3QF5WQ",
            "brand": "sams"
          },
          {
            "order": 75,
            "price": "Rs 119.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Wasabi-Mayonnaise/dp/B07CQ1956D/",
            "page_count": 48,
            "reviews": 46,
            "ratings": 4.2,
            "image_count": 3,
            "product_name": "Wingreens Farms Wasabi Mayonnaise, 130g",
            "item_id": "B07CQ1956D",
            "brand": "wingreens farms"
          },
          {
            "order": 76,
            "price": "",
            "offer": "Rs 595.00",
            "page": 2,
            "link": "https//www.amazon.in//Jimmys-Gourmet-Kitchen-Mayonnaise-Avocado/dp/B07H973KYN/",
            "page_count": 48,
            "reviews": 25,
            "ratings": 3.8,
            "image_count": 7,
            "product_name": "Jimmy's Gourmet Kitchen Mayonnaise Wild Herbs Avocado Oil Egg Free 225gms (Italian Wild Herbs Mayonnaise)",
            "item_id": "B07H973KYN",
            "brand": "jimmy's gourmet kitchen"
          },
          {
            "order": 77,
            "price": "Rs 175.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Ks-Kitchen-TIkka-Mayonnaise-250g/dp/B06W2L2NDD/",
            "page_count": 48,
            "reviews": 8,
            "ratings": 4.7,
            "image_count": 4,
            "product_name": "K's Kitchen Tikka Mayonnaise, 250g",
            "item_id": "B06W2L2NDD",
            "brand": "k's kitchen"
          },
          {
            "order": 78,
            "price": "Rs 117.00",
            "offer": "Rs 138.00",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Smart-Mayonnaise-275g-Pack/dp/B01N132CQI/",
            "page_count": 48,
            "reviews": 17,
            "ratings": 4.2,
            "image_count": 1,
            "product_name": "Veeba Smart Mayonnaise, 275g (Pack of 2)",
            "item_id": "B01N132CQI",
            "brand": "veeba"
          },
          {
            "order": 79,
            "price": "Rs 101.00",
            "offer": "\nRs 119.00",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Mint-Mayo-130/dp/B07VSY6T21/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 3.5,
            "image_count": 4,
            "product_name": "Wingreens Farms Mint Mayo, 130 g",
            "item_id": "B07VSY6T21",
            "brand": "wingreens farms"
          },
          {
            "order": 80,
            "price": "",
            "offer": "Rs 595.00",
            "page": 2,
            "link": "https//www.amazon.in//Jimmys-Gourmet-Kitchen-Mayonnaise-Preservative/dp/B08Q7CMDYG/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "Jimmy's Gourmet Kitchen Vegan Mayonnaise with Wild Herbs and Aged Balsamic, Dairy Free, Gluten Free, Preservative Free, Sugar Free, No Palm Oil Added, No Artificial Flavor Added, 225gms",
            "item_id": "B08Q7CMDYG",
            "brand": "jimmy's gourmet kitchen"
          },
          {
            "order": 81,
            "price": "Rs 130.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Frapito-Eggless-Mayonnaise-Creamy-Spread/dp/B08P79G7YM/",
            "page_count": 48,
            "reviews": 4,
            "ratings": 5,
            "image_count": 5,
            "product_name": "Frapito Eggless Mayonnaise Lite Creamy, Tasty|Spread Dip| 400gm",
            "item_id": "B08P79G7YM",
            "brand": "frapito"
          },
          {
            "order": 82,
            "price": "",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//ENE-JOLOKIA-Chilli-Mayonnaise-200GMS/dp/B08GKSRVCS/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "ENE BHUT JOLOKIA Chilli Mayonnaise 200GMS (Pack of Two)",
            "item_id": "B08GKSRVCS",
            "brand": "ene"
          },
          {
            "order": 83,
            "price": "Rs 120.00",
            "offer": "Rs 138.00",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Classic-Mayonnaise-275g-Pack/dp/B06WVR9RGL/",
            "page_count": 48,
            "reviews": 37,
            "ratings": 4,
            "image_count": 6,
            "product_name": "Veeba Classic Mayonnaise, 250g (Pack of 2)",
            "item_id": "B06WVR9RGL",
            "brand": "veeba"
          },
          {
            "order": 84,
            "price": "Rs 230.00",
            "offer": "Rs 250.00",
            "page": 2,
            "link": "https//www.amazon.in//Nutralite-Veg-Mayonnaise-275-Pack/dp/B07H8Q17D4/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 5,
            "product_name": "Nutralite Veg Mayonnaise, 275 Gm (Pack of 3)",
            "item_id": "B07H8Q17D4",
            "brand": "nutralite"
          },
          {
            "order": 85,
            "price": "Rs 240.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Oceans-Secrets-Chicken-Mayonnaise-400g/dp/B07HRM89BS/",
            "page_count": 48,
            "reviews": 9,
            "ratings": 3.9,
            "image_count": 4,
            "product_name": "Oceans Secrets Chicken Mayonnaise 400g",
            "item_id": "B07HRM89BS",
            "brand": "oceans secrets"
          },
          {
            "order": 86,
            "price": "Rs 314.00",
            "offer": "Rs 315.00",
            "page": 2,
            "link": "https//www.amazon.in//Surabh-Premium-Regular-Cheesy-Mayonnaise/dp/B08HKC5VV2/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "Surabh Premium (Combo of Regular, Cheesy Mayo, Cheese Chilli Mayo) Mayonnaise (Each 3 Packs) 85 GMS Each Pack",
            "item_id": "B08HKC5VV2",
            "brand": "bhavani foods"
          },
          {
            "order": 87,
            "price": "Rs 119.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Mint-Mayonnaise/dp/B07CQ4MN9K/",
            "page_count": 48,
            "reviews": 25,
            "ratings": 4,
            "image_count": 3,
            "product_name": "Wingreens Farms Mint Mayonnaise, 130g",
            "item_id": "B07CQ4MN9K",
            "brand": "wingreens farms"
          },
          {
            "order": 88,
            "price": "Rs 570.00",
            "offer": "Rs 600.00",
            "page": 2,
            "link": "https//www.amazon.in//Urban-Platter-Dairy-Free-Mayonnaise-Trans-Fat/dp/B07P7QH7WD/",
            "page_count": 48,
            "reviews": 4,
            "ratings": 4.7,
            "image_count": 7,
            "product_name": "Urban Platter Vegan Premium Mayo, 1Kg / 35.27oz [Dairy-Free Mayonnaise, No Palm Oil, No Trans-Fat] [HoReCa]",
            "item_id": "B07P7QH7WD",
            "brand": "urban platter"
          },
          {
            "order": 89,
            "price": "Rs 153.10",
            "offer": "Rs 174.00",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-Special-Tomato/dp/B08BVHM9FD/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 3.2,
            "image_count": 3,
            "product_name": "Veeba Eggless Mayonnaise Chef's Special (100g)+ Hot Sweet Tomato Chilli Sauce - No Added preservatives (100g) - Pack of 6 (3 sachets Each)",
            "item_id": "B08BVHM9FD",
            "brand": "veeba"
          },
          {
            "order": 90,
            "price": "",
            "offer": "Rs 298.00",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Olive-Mayonnaise-300g-Pack/dp/B01CA0X9C8/",
            "page_count": 48,
            "reviews": 3,
            "ratings": 4.4,
            "image_count": 4,
            "product_name": "Veeba Olive Oil Mayonnaise, 300g - Pack of 2",
            "item_id": "B01CA0X9C8",
            "brand": "veeba"
          },
          {
            "order": 91,
            "price": "",
            "offer": "Rs 290.00",
            "page": 2,
            "link": "https//www.amazon.in//Nandos-Perinaise-Mayonnaise-Product-Netherlands/dp/B084G86QBQ/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 2,
            "product_name": "Nando's Perinaise Mayonnaise, Vegan, 265g, Product of The Netherlands",
            "item_id": "B084G86QBQ",
            "brand": "nando's"
          },
          {
            "order": 92,
            "price": "Rs 119.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Wingreens-Farms-Italian-Herb-Mayonnaise/dp/B07CQ32BN5/",
            "page_count": 48,
            "reviews": 30,
            "ratings": 4.1,
            "image_count": 3,
            "product_name": "Wingreens Farms Italian Herb Mayonnaise, 130g",
            "item_id": "B07CQ32BN5",
            "brand": "wingreens farms"
          },
          {
            "order": 93,
            "price": "Rs 69.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Funfoods-Mayo-GreenMint-275g/dp/B071KF4S87/",
            "page_count": 48,
            "reviews": 26,
            "ratings": 3.7,
            "image_count": 3,
            "product_name": "Funfoods Mayonnaise GreenMint, 275g",
            "item_id": "B071KF4S87",
            "brand": "funfoods"
          },
          {
            "order": 94,
            "price": "Rs 899.00",
            "offer": "Rs 1,200.00",
            "page": 2,
            "link": "https//www.amazon.in//Japanese-Kewpie-Mayonnaise-17-64-oz/dp/B0000WKU8K/",
            "page_count": 48,
            "reviews": 273,
            "ratings": 4.4,
            "image_count": 4,
            "product_name": "Japanese Kewpie Mayonnaise - 17.64 oz.",
            "item_id": "B0000WKU8K",
            "brand": "kewpie"
          },
          {
            "order": 95,
            "price": "Rs 69.00",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Veeba-Mayonnaise-Smart-275g-Jar/dp/B077YXBX8H/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 4,
            "product_name": "Veeba Mayonnaise - Smart, 275g Jar",
            "item_id": "B077YXBX8H",
            "brand": "veeba"
          },
          {
            "order": 96,
            "price": "",
            "offer": "",
            "page": 2,
            "link": "https//www.amazon.in//Bakers-Eggless-Mayonnaise-250gm-Pack/dp/B08P8S84D7/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 2,
            "product_name": "Bakers Eggless Mayonnaise 250gm - Pack of 2",
            "item_id": "B08P8S84D7",
            "brand": "generic"
          },
          {
            "order": 97,
            "price": "Rs 152.00",
            "offer": "Rs 168.00",
            "page": 3,
            "link": "https//www.amazon.in//VEEBA-EGGLESS-CHILLI-MAYONNAISE-PACK/dp/B06WVT6L16/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 4,
            "image_count": 3,
            "product_name": "VEEBA EGGLESS CHILLI MAYONNAISE (PACK OF 2)",
            "item_id": "B06WVT6L16",
            "brand": "veeba"
          },
          {
            "order": 98,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//American-Garden-Mayonnaise-237ml-Bottle/dp/B013WOQRSY/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 1,
            "product_name": "American Garden Mayonnaise - Lite, 237ml Bottle",
            "item_id": "B013WOQRSY",
            "brand": "american garden"
          },
          {
            "order": 99,
            "price": "Rs 245.00",
            "offer": "Rs 499.00",
            "page": 3,
            "link": "https//www.amazon.in//Sawad-Sadan-Cremica-Spread-Tandoori/dp/B08L6KB2C1/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "Sawad Sadan Cremica Bread Spread Tandoori",
            "item_id": "B08L6KB2C1",
            "brand": "generic"
          },
          {
            "order": 100,
            "price": "Rs 59.00",
            "offer": "Rs 69.00",
            "page": 3,
            "link": "https//www.amazon.in//Fun-Food-Mayonnaise-Olive-Bottle/dp/B00Y00ZGQE/",
            "page_count": 48,
            "reviews": 4,
            "ratings": 4.2,
            "image_count": 4,
            "product_name": "Funfoods Veg Mayonnaise - Eggless Olive Oil, 250g",
            "item_id": "B00Y00ZGQE",
            "brand": "fun foods"
          },
          {
            "order": 101,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Bakers-Egg-Mayonnaise-250gm-Pack/dp/B08P8TXMS2/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 2,
            "product_name": "Bakers Egg Mayonnaise 250gm - Pack of 2",
            "item_id": "B08P8TXMS2",
            "brand": "generic"
          },
          {
            "order": 102,
            "price": "Rs 139.00",
            "offer": "Rs 160.00",
            "page": 3,
            "link": "https//www.amazon.in//Lifoodil-Premium-Eggless-Mayonnaise-Tandoori/dp/B08M5VCJFQ/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "Lifoodil Premium Eggless Mayonnaise and Tandoori Mayonnaise, 200g + 200g",
            "item_id": "B08M5VCJFQ",
            "brand": "lifoodil"
          },
          {
            "order": 103,
            "price": "Rs 340.00",
            "offer": "Rs 350.00",
            "page": 3,
            "link": "https//www.amazon.in//Urban-Platter-Dairy-Free-Mayonnaise-Trans-Fat/dp/B07L8YR7FF/",
            "page_count": 48,
            "reviews": 26,
            "ratings": 3.8,
            "image_count": 7,
            "product_name": "Urban Platter Vegan Chipotle Mayo, 300g / 10.6oz [Dairy-Free Mayonnaise, No Palm Oil, No Trans-Fat]",
            "item_id": "B07L8YR7FF",
            "brand": "urban platter"
          },
          {
            "order": 104,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//American-Garden-Mayonnaise-Lite-16oz/dp/B008IJ9XRQ/",
            "page_count": 48,
            "reviews": 17,
            "ratings": 3.9,
            "image_count": 5,
            "product_name": "American Garden Mayonnaise Lite 16oz",
            "item_id": "B008IJ9XRQ",
            "brand": "american garden"
          },
          {
            "order": 105,
            "price": "Rs 960.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//SIL-Egg-Mayonnaise-200g-Pack/dp/B08HKBTDGR/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 1,
            "image_count": 6,
            "product_name": "SIL Egg Mayonnaise (200g) (Pack of 12)",
            "item_id": "B08HKBTDGR",
            "brand": "sil"
          },
          {
            "order": 106,
            "price": "",
            "offer": "Rs 725.00",
            "page": 3,
            "link": "https//www.amazon.in//Jimmys-Gourmet-Kitchen-Mayonnaise-Ketogenic/dp/B08Q7SC19D/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "Jimmy's Gourmet Kitchen Keto Mayonnaise Wild Herbs with Aged Balsamic, 10.6g Fat, 1.66g Carbs per Serving, Ketogenic Diet, Vegan, Gluten Free, 225gms",
            "item_id": "B08Q7SC19D",
            "brand": "jimmy's gourmet kitchen"
          },
          {
            "order": 107,
            "price": "",
            "offer": "Rs 725.00",
            "page": 3,
            "link": "https//www.amazon.in//Jimmys-Gourmet-Kitchen-Mayonnaise-Mexican/dp/B08Q7FZG4F/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 7,
            "product_name": "Jimmy's Gourmet Kitchen Keto Mayonnaise Smoked Mexican Chilies, 10.6g Fat, 1.66g Carbs, Keto - Vegan - Gluten Free, 225g",
            "item_id": "B08Q7FZG4F",
            "brand": "jimmy's gourmet kitchen"
          },
          {
            "order": 108,
            "price": "",
            "offer": "Rs 595.00",
            "page": 3,
            "link": "https//www.amazon.in//Jimmys-Gourmet-Kitchen-Mayonnaise-Preservative/dp/B08Q7PPP2S/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 1,
            "image_count": 7,
            "product_name": "Jimmy's Gourmet Kitchen Vegan Mayonnaise Smoked Mexican Chilies, Dairy Free, Gluten Free, Preservative Free, Sugar Free, No Palm Oil Added, No Artificial Flavor Added, 225gms",
            "item_id": "B08Q7PPP2S",
            "brand": "jimmy's gourmet kitchen"
          },
          {
            "order": 109,
            "price": "Rs 177.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//ELLIS-HARVEY-Cremica-Premium-Mayonnaise/dp/B07MHNCCG2/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 4,
            "image_count": 2,
            "product_name": "ELLIS HARVEY Cremica Premium Mayonnaise Chef's Choice",
            "item_id": "B07MHNCCG2",
            "brand": "ellis harvey"
          },
          {
            "order": 110,
            "price": "Rs 140.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//PRAHANT-Eggless-Mayonnaise-Swaminarayan-Thousand/dp/B08KLSXFX3/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 3,
            "product_name": "PRAHANT Eggless Mayonnaise - 200 gm [Swaminarayan -No Onion, No Garlic, Pack of 1] (Thousand Island)",
            "item_id": "B08KLSXFX3",
            "brand": "prahant"
          },
          {
            "order": 111,
            "price": "Rs 134.00",
            "offer": "Rs 138.00",
            "page": 3,
            "link": "https//www.amazon.in//Veeba-Garlic-Mayonnaise-280g-Pack/dp/B01NBWD4HN/",
            "page_count": 48,
            "reviews": 29,
            "ratings": 4.2,
            "image_count": 1,
            "product_name": "Veeba Garlic Mayonnaise, 280g (Pack of 2)",
            "item_id": "B01NBWD4HN",
            "brand": "veeba"
          },
          {
            "order": 112,
            "price": "Rs 349.00",
            "offer": "Rs 549.00",
            "page": 3,
            "link": "https//www.amazon.in//Black-Avocado-Mayonnaise-Sandwiches-Dressings/dp/B084ZSQ1MC/",
            "page_count": 48,
            "reviews": 19,
            "ratings": 4.1,
            "image_count": 6,
            "product_name": "Black and Green's Extra Virgin Avocado Oil Mayonnaise (Good Fat Classic), 200 GMS",
            "item_id": "B084ZSQ1MC",
            "brand": "black and green"
          },
          {
            "order": 113,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Bakers-Jalapeno-Cheese-Mayonnaise-250gm/dp/B08P8S4TFZ/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 5,
            "image_count": 2,
            "product_name": "Bakers Jalapeno Cheese Mayonnaise 250gm - Pack of 2",
            "item_id": "B08P8S4TFZ",
            "brand": "generic"
          },
          {
            "order": 114,
            "price": "Rs 174.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-Special-Classic/dp/B08BVKMGM9/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 3.3,
            "image_count": 3,
            "product_name": "Veeba Eggless Mayonnaise Chef's Special (100g)+ Classic Imli - No Added preservatives (100g) - Pack of 6 (3 sachets Each)",
            "item_id": "B08BVKMGM9",
            "brand": "veeba"
          },
          {
            "order": 115,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Hellmanns-Vegan-Mayo-Mayonnaise-270g/dp/B07PRLSB88/",
            "page_count": 48,
            "reviews": 10,
            "ratings": 4.9,
            "image_count": 7,
            "product_name": "Hellmann's Vegan Mayonnaise, 270 g",
            "item_id": "B07PRLSB88",
            "brand": "hellmann's"
          },
          {
            "order": 116,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Hellmanns-Mayonnaise-Squeeze-Bottle-430ml/dp/B003UU59Y4/",
            "page_count": 48,
            "reviews": 24,
            "ratings": 4.1,
            "image_count": 5,
            "product_name": "Hellmann's Real Mayonnaise Squeeze Bottle, 430ml",
            "item_id": "B003UU59Y4",
            "brand": "hellmann's"
          },
          {
            "order": 117,
            "price": "Rs 407.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Veeba-Caesar-Dressing-Mayonnaise-Thousand/dp/B01CA0XQQW/",
            "page_count": 48,
            "reviews": 18,
            "ratings": 4.4,
            "image_count": 1,
            "product_name": "Veeba Caesar Dressing, 300g with Olive Oil Mayonnaise, 300g and Thousand Island Dressing, 300g",
            "item_id": "B01CA0XQQW",
            "brand": "veeba"
          },
          {
            "order": 118,
            "price": "Rs 155.00",
            "offer": "Rs 175.00",
            "page": 3,
            "link": "https//www.amazon.in//Meal-Time-Mayonnaise-Eggless-Kg/dp/B01N3L7UNX/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 3,
            "product_name": "Meal Time Mayonnaise (Eggless), 1 Kg",
            "item_id": "B01N3L7UNX",
            "brand": "meal time"
          },
          {
            "order": 119,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//American-Garden-U-S-Mayonnaise-237ml/dp/B005UGW5R0/",
            "page_count": 48,
            "reviews": 26,
            "ratings": 3.5,
            "image_count": 5,
            "product_name": "American Garden U.S. Mayonnaise, 237ml",
            "item_id": "B005UGW5R0",
            "brand": "american garden"
          },
          {
            "order": 120,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Nandos-Perinaise-Peri-Mayonnaise-265g/dp/B07467QFQ1/",
            "page_count": 48,
            "reviews": 14,
            "ratings": 4.6,
            "image_count": 1,
            "product_name": "Nando's Perinaise Peri Peri Mayonnaise, 265g",
            "item_id": "B07467QFQ1",
            "brand": "nando's"
          },
          {
            "order": 121,
            "price": "Rs 550.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//MASALA-MONK-Eggless-Kasundi-Mayonnaise/dp/B08BRJRD4X/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "MASALA MONK Eggless Kasundi Mustard Mayonnaise - 220 GMS",
            "item_id": "B08BRJRD4X",
            "brand": "masala monk"
          },
          {
            "order": 122,
            "price": "Rs 150.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Sams-Mayonnaise-Vegetarian-Homemade-Delicious/dp/B08K3M7F1K/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 4.7,
            "image_count": 7,
            "product_name": "Sams Veg Mayonnaise 90 Grams Pack of 5 Eggless Mayo Vegetarian Mayo Fresh Farm for Homemade Recipe Delicious Thick Mayonnaise Spreads and Dips",
            "item_id": "B08K3M7F1K",
            "brand": "sams"
          },
          {
            "order": 123,
            "price": "Rs 120.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Del-Monte-Mayonnaise-Eggless-Pouch/dp/B08C2BQ2BN/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 4.3,
            "image_count": 6,
            "product_name": "Del Monte Mayonnaise - Eggless, 500g Pouch",
            "item_id": "B08C2BQ2BN",
            "brand": "del monte"
          },
          {
            "order": 124,
            "price": "Rs 30.00",
            "offer": "Rs 35.00",
            "page": 3,
            "link": "https//www.amazon.in//Oetker-Foods-Burger-Mayonnaise-100g/dp/B0845Y4J7R/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 4.7,
            "image_count": 6,
            "product_name": "Dr. Oetker Dr Oetker Fun Foods Veg Burger Mayonnaise, 100g",
            "item_id": "B0845Y4J7R",
            "brand": "dr oetker"
          },
          {
            "order": 125,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Veeba-Mint-Mayonnaise-300g-Pack/dp/B01CA0X7MK/",
            "page_count": 48,
            "reviews": 3,
            "ratings": 4.8,
            "image_count": 7,
            "product_name": "Veeba Mint Mayonnaise, 300g - Pack of 2",
            "item_id": "B01CA0X7MK",
            "brand": "veeba"
          },
          {
            "order": 126,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Veeba-Eggless-Mayonnaise-250-Gram/dp/B08KLPPQ5P/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "Veeba Eggless Mayonnaise, 250 Gram",
            "item_id": "B08KLPPQ5P",
            "brand": "veeba"
          },
          {
            "order": 127,
            "price": "Rs 299.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Garlic-Delicious-eggless-Mayonnaise-Flavourful/dp/B08MLDNQLX/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "SPRIG Black Garlic AIOLI | Delicious eggless dip | Better Than Mayonnaise | Twist of Flavourful Black Garlic | 260g",
            "item_id": "B08MLDNQLX",
            "brand": "sprig"
          },
          {
            "order": 128,
            "price": "Rs 69.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Funfoods-Mayo-Veg-275g/dp/B01CSFWVMO/",
            "page_count": 48,
            "reviews": 15,
            "ratings": 4.3,
            "image_count": 1,
            "product_name": "Funfoods Mayo Veg 275g",
            "item_id": "B01CSFWVMO",
            "brand": "funfoods"
          },
          {
            "order": 129,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Bakers-Tandoori-Mayonnaise-250gm-Pack/dp/B08P8S5HXC/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 2,
            "product_name": "Bakers Tandoori Mayonnaise 250gm - Pack of 2",
            "item_id": "B08P8S5HXC",
            "brand": "generic"
          },
          {
            "order": 130,
            "price": "Rs 175.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Ks-Kitchen-Spicy-Chipotle-Mayonnaise/dp/B06X3WD11D/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 3.3,
            "image_count": 4,
            "product_name": "K's Kitchen Spicy Chipotle Mayonnaise Dressing, 250g",
            "item_id": "B06X3WD11D",
            "brand": "k's kitchen"
          },
          {
            "order": 131,
            "price": "Rs 262.00",
            "offer": "Rs 278.00",
            "page": 3,
            "link": "https//www.amazon.in//Veeba-Mint-Mayonnaise-Sweet-Onion/dp/B01M8P0QHV/",
            "page_count": 48,
            "reviews": 5,
            "ratings": 4.3,
            "image_count": 3,
            "product_name": "Veeba Mint Mayonnaise, 300g with Sweet Onion, 350g - Pack of 2",
            "item_id": "B01M8P0QHV",
            "brand": "veeba"
          },
          {
            "order": 132,
            "price": "Rs 440.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Easy-Life-Mayonnaise-Oregano-Seasoning/dp/B06Y2J9XP6/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "Easy Life Peri Peri Mayonnaise 315g (2 Packs) + Oregano Seasoning 60g + Peri Peri Seasoning 40g (Combo of 4)",
            "item_id": "B06Y2J9XP6",
            "brand": "easy life"
          },
          {
            "order": 133,
            "price": "Rs 120.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//MONTIS-Italian-Herbs-Mayonnaise-400-Grams/dp/B07PJTCHW2/",
            "page_count": 48,
            "reviews": 9,
            "ratings": 3.7,
            "image_count": 3,
            "product_name": "MONTIS - Italian Herb Mayonnaise 400g",
            "item_id": "B07PJTCHW2",
            "brand": "montis"
          },
          {
            "order": 134,
            "price": "Rs 186.00",
            "offer": "Rs 210.00",
            "page": 3,
            "link": "https//www.amazon.in//Easy-Life-Mayonnaise-Seasoning-Especially/dp/B06ZZQS73L/",
            "page_count": 48,
            "reviews": 1,
            "ratings": 4.4,
            "image_count": 5,
            "product_name": "Easy Life Combo of Classic Mayonnaise 315g and Salad Seasoning 40g (A Perfect Condiment Set Especially for Salads and Sandwich)",
            "item_id": "B06ZZQS73L",
            "brand": "easy life"
          },
          {
            "order": 135,
            "price": "Rs 30.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Del-Monte-Eggless-Mayo-Spout/dp/B0821XQ6FP/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 1,
            "product_name": "Del Monte Eggless Mayo Spout Pack, 80g",
            "item_id": "B0821XQ6FP",
            "brand": "del monte"
          },
          {
            "order": 136,
            "price": "Rs 90.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//JJ-Madhur-Veg-Mayonnaise-275/dp/B08G7YGQ26/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 6,
            "product_name": "JJ Madhur Veg. Mayonnaise ( 275 GM )",
            "item_id": "B08G7YGQ26",
            "brand": ""
          },
          {
            "order": 137,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Funfoods-Mayonnaise-Classic-270g-Jar/dp/B0749MH9DQ/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 4,
            "product_name": "Funfoods Mayonnaise - Classic, 270g Jar",
            "item_id": "",
            "brand": ""
          },
          {
            "order": 138,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Funfoods-Mayonnaise-Eggless-100g-Packet/dp/B01MRP73FT/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 0,
            "image_count": 4,
            "product_name": "Funfoods Mayonnaise - Eggless, 100g Packet",
            "item_id": "",
            "brand": ""
          },
          {
            "order": 139,
            "price": "Rs 189.00",
            "offer": "Rs 299.00",
            "page": 3,
            "link": "https//www.amazon.in//GreenFinity%C2%AE-Mayo-250g-Lets-Make/dp/B08CNMFDXD/",
            "page_count": 48,
            "reviews": 5,
            "ratings": 3.4,
            "image_count": 6,
            "product_name": "GreenFinity® Mayo Veg 250g. | Lets Make It.",
            "item_id": "B08CNMFDXD",
            "brand": "greenfinity"
          },
          {
            "order": 140,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Heinz-Spicy-Tikka-Masala-Mayonnaise/dp/B01LGX23J0/",
            "page_count": 48,
            "reviews": 12,
            "ratings": 3.1,
            "image_count": 1,
            "product_name": "Heinz Spicy Tikka Masala Mayonnaise, 400ml",
            "item_id": "B01LGX23J0",
            "brand": "heinz"
          },
          {
            "order": 141,
            "price": "Rs 427.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Aaina-Mayonnaise-Thousand-Dressing-Barbeque/dp/B01CA0XNY2/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 3.2,
            "image_count": 4,
            "product_name": "Aaina Veeba Combo Olive Oil Mayonnaise, Thousand Island Dressing & Barbeque Sauce",
            "item_id": "B01CA0XNY2",
            "brand": "aaina"
          },
          {
            "order": 142,
            "price": "",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//Veeba-Chilli-Mayonnaise-275g-Pack/dp/B01NAVDWUF/",
            "page_count": 48,
            "reviews": 12,
            "ratings": 4,
            "image_count": 7,
            "product_name": "Veeba Chilli Mayonnaise, 275g (Pack of 2)",
            "item_id": "B01NAVDWUF",
            "brand": "veeba"
          },
          {
            "order": 143,
            "price": "Rs 550.00",
            "offer": "",
            "page": 3,
            "link": "https//www.amazon.in//MASALA-MONK-Homemade-Eggless-Mayonnaise/dp/B08BRQN4V7/",
            "page_count": 48,
            "reviews": 0,
            "ratings": 2,
            "image_count": 6,
            "product_name": "MASALA MONK Homemade Eggless Achari Mayonnaise - 220gms",
            "item_id": "B08BRQN4V7",
            "brand": "masala monk"
          },
          {
            "order": 144,
            "price": "Rs 260.00",
            "offer": "Rs 301.00",
            "page": 3,
            "link": "https//www.amazon.in//Del-Monte-Eggless-Mayonnaise-1Kg/dp/B07XTMKF6F/",
            "page_count": 48,
            "reviews": 2,
            "ratings": 3.8,
            "image_count": 4,
            "product_name": "Del Monte Eggless Mayonnaise 1Kg",
            "item_id": "B07XTMKF6F",
            "brand": "del monte"
          }
        ]
        if(self.catType !='mayonnaise')
        {
          resData = [
            {
              "order": 1,
              "price": "Rs 378.00",
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Natural-Crunchy-Unsweetened-Non-GMO/dp/B06XFSSDNH/",
              "page_count": 48,
              "reviews": 7264,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Pintola All Natural Peanut Butter (Crunchy) (1 kg) (Unsweetened, Non-GMO, Gluten Free, Vegan)",
              "item_id": "B06XFSSDNH",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 2,
              "price": "Rs 549.00",
              "offer": "Rs 649.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Chocolate-Peanut-Butter-1250g/dp/B07RZ7RPRD/",
              "page_count": 48,
              "reviews": 4995,
              "ratings": 4.8,
              "image_count": 4,
              "product_name": "MYFITNESS Chocolate Peanut Butter Smooth 1250g",
              "item_id": "B07RZ7RPRD",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 3,
              "price": null,
              "offer": "Rs 500.00",
              "page": 1,
              "link": "https://www.amazon.in//Disano-Natural-Unsweetened-Peanut-Crunchy/dp/B07L2WKL56/",
              "page_count": 48,
              "reviews": 910,
              "ratings": 4,
              "image_count": 6,
              "product_name": "DiSano All Natural Peanut Butter, Crunchy, 30% Protein, Unsweetened, Gluten Free, 1 Kg",
              "item_id": "B07L2WKL56",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 4,
              "price": "Rs 399.00",
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Alpino-Natural-Peanut-Butter-Unsweetened/dp/B077S4V3V9/",
              "page_count": 48,
              "reviews": 4840,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Alpino Natural Peanut Butter Crunch 1 KG | Unsweetened | Made with 100% Roasted Peanuts | 30% Protein | No Added Sugar | No Added Salt | No Hydrogenated Oils | Non GMO | Gluten Free | Vegan",
              "item_id": "B077S4V3V9",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 5,
              "price": "Rs 310.00",
              "offer": "Rs 320.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Original-Peanut-Butter-Chocolate/dp/B07QMJ8RT5/",
              "page_count": 48,
              "reviews": 1323,
              "ratings": 4.7,
              "image_count": 7,
              "product_name": "MYFITNESS Chocolate Peanut Butter Smooth 510g",
              "item_id": "B07QMJ8RT5",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 6,
              "price": "Rs 379.00",
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//MuscleBlaze-Protein-Natural-Unsweetened-Crunchy/dp/B07MPP9M4F/",
              "page_count": 48,
              "reviews": 420,
              "ratings": 4,
              "image_count": 7,
              "product_name": "MuscleBlaze High Protein Natural Peanut Butter Unsweetened, Crunchy Delight,750g (Crunchy Delight, 750g)",
              "item_id": "B07MPP9M4F",
              "brand": "muscleblaze",
              "client": "oetker"
            },
            {
              "order": 7,
              "price": "Rs 299.00",
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Trubite-Natural-Crunchy-Unsweetened-Cholesterol/dp/B08K4B3D1Y/",
              "page_count": 48,
              "reviews": 127,
              "ratings": 4.6,
              "image_count": 6,
              "product_name": "Trubite Natural Peanut Butter (Crunchy) (1kg) | Unsweetened | 30g Protein | Non GMO | Gluten Free | Cholesterol Free",
              "item_id": "B08K4B3D1Y",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 8,
              "price": "Rs 572.00",
              "offer": "Rs 648.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Peanut-Butter-Crunchy-1250g/dp/B07HB5C7C8/",
              "page_count": 48,
              "reviews": 1638,
              "ratings": 4.7,
              "image_count": 6,
              "product_name": "MYFITNESS Original Peanut Butter Crunchy 1250g",
              "item_id": "B07HB5C7C8",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 9,
              "price": null,
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//Nutrition-AS-Crunchy-Natural-Unsweetened/dp/B07NMGTLLV/",
              "page_count": 48,
              "reviews": 491,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Asitis Nutrition AS-IT-IS Peanut Butter Crunchy (Natural and Unsweetened) 1 Kg",
              "item_id": "B07NMGTLLV",
              "brand": "asitis nutrition",
              "client": "oetker"
            },
            {
              "order": 10,
              "price": "Rs 300.00",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Crunchy-924g/dp/B01KA8P538/",
              "page_count": 48,
              "reviews": 1178,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Sundrop Peanut Butter, Crunchy, 924g",
              "item_id": "B01KA8P538",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 11,
              "price": null,
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Natural-Creamy-Unsweetened-Non-GMO/dp/B06XFVG7R8/",
              "page_count": 48,
              "reviews": 1965,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "All Natural Peanut Butter Creamy (1 kg)",
              "item_id": "B06XFVG7R8",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 12,
              "price": "Rs 159.00",
              "offer": "Rs 249.00",
              "page": 1,
              "link": "https://www.amazon.in//Yogabar-Chocolate-Chocolatey-Roasted-Non-GMO/dp/B08LZFLY7L/",
              "page_count": 48,
              "reviews": 435,
              "ratings": 3.9,
              "image_count": 7,
              "product_name": "Yogabar Dark Chocolate Peanut Butter| Creamy & Chocolatey | Slow Roasted | Non-GMO Premium Peanuts | 400gm",
              "item_id": "B08LZFLY7L",
              "brand": "yogabar",
              "client": "oetker"
            },
            {
              "order": 13,
              "price": "Rs 284.00",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in//Funfoods-Peanutbutter-Crunchy-925g/dp/B07531WR8R/",
              "page_count": 48,
              "reviews": 275,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Dr. Oetker Fun Foods Peanut Butter Crunchy, 925g",
              "item_id": "B07531WR8R",
              "brand": "dr. oetker fun foods",
              "client": "oetker"
            },
            {
              "order": 14,
              "price": "Rs 279.00",
              "offer": "Rs 349.00",
              "page": 1,
              "link": "https://www.amazon.in//MuscleBlaze-Natural-Peanut-Butter-Creamy/dp/B08NCQ28DS/",
              "page_count": 48,
              "reviews": 121,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "MuscleBlaze Natural Peanut Butter (Creamy, 750g)",
              "item_id": "B08NCQ28DS",
              "brand": "muscleblaze",
              "client": "oetker"
            },
            {
              "order": 15,
              "price": "Rs 399.00",
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Natural-Peanut-Crunchy-Unsweetened/dp/B07MHFR24F/",
              "page_count": 48,
              "reviews": 846,
              "ratings": 4.6,
              "image_count": 7,
              "product_name": "MYFITNESS Gold Natural Peanut Butter Crunchy 1Kg (Unsweetened)",
              "item_id": "B07MHFR24F",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 16,
              "price": "Rs 275.00",
              "offer": "Rs 300.00",
              "page": 1,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Crunchy-924g/dp/B01MZXHF28/",
              "page_count": 48,
              "reviews": 358,
              "ratings": 4.4,
              "image_count": 5,
              "product_name": "Sundrop Peanut Butter, Crunchy, 924g",
              "item_id": "B01MZXHF28",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 17,
              "price": "Rs 369.00",
              "offer": "Rs 449.00",
              "page": 1,
              "link": "https://www.amazon.in//Trubite-Chocolate-Goodness-Cholesterol-Antioxidant/dp/B08K4D2JG8/",
              "page_count": 48,
              "reviews": 77,
              "ratings": 4.7,
              "image_count": 6,
              "product_name": "Trubite Chocolate Peanut Butter (Creamy) (1kg) | High in Protein | Goodness of Dark Chocolate | No Cholesterol | Rich in Antioxidant",
              "item_id": "B08K4D2JG8",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 18,
              "price": null,
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in//Disano-Natural-Unsweetened-Peanut-Butter/dp/B07L2WVRPR/",
              "page_count": 48,
              "reviews": 1121,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "DiSano Unsweetened peanut butter 100% natural(high in protein,no hydrogenated oil,gluten free) 1 Kg",
              "item_id": "B07L2WVRPR",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 19,
              "price": "Rs 399.00",
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Alpino-Chocolate-Peanut-Butter-1kg/dp/B071NKV55W/",
              "page_count": 48,
              "reviews": 1484,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Alpino Chocolate Peanut Butter Smooth 1 KG | Made with Roasted Peanuts, Cocoa Powder & Choco Chips | 20% Protein | Non GMO | Gluten Free | Vegan",
              "item_id": "B071NKV55W",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 20,
              "price": null,
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Organic-Natural-Unsweetened-Non-GMO/dp/B079QKNJT8/",
              "page_count": 48,
              "reviews": 848,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Pintola Organic Peanut Butter (Creamy) (1kg)",
              "item_id": "B079QKNJT8",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 21,
              "price": null,
              "offer": "Rs 285.00",
              "page": 1,
              "link": "https://www.amazon.in//Disano-Peanut-Butter-Crunchy-Jar/dp/B07JNF7R7X/",
              "page_count": 48,
              "reviews": 575,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "DiSano Peanut Butter, Crunchy, (Zero cholesterol&Transfat,High in fibre &protein) 1 Kg",
              "item_id": "B07JNF7R7X",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 22,
              "price": "Rs 399.00",
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//MuscleBlaze-Protein-Peanut-Butter-Chocolate/dp/B08GKC17MT/",
              "page_count": 48,
              "reviews": 107,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "MuscleBlaze High Protein Peanut Butter,750g (Dark Chocolate) (Dark Chocolate, 750g)",
              "item_id": "B08GKC17MT",
              "brand": "muscleblaze",
              "client": "oetker"
            },
            {
              "order": 23,
              "price": "Rs 146.00",
              "offer": "Rs 165.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Natural-Peanut-Butter-Crunchy/dp/B07DM669SB/",
              "page_count": 48,
              "reviews": 984,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Pintola All Natural Peanut Butter (Extra Crunchy) (Unsweetened) (350g)",
              "item_id": "B07DM669SB",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 24,
              "price": "Rs 299.00",
              "offer": "Rs 320.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Chocolate-Peanut-Butter-Crispy/dp/B08TM8HWQQ/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 3,
              "product_name": "MYFITNESS Chocolate Peanut Butter Crispy 510g",
              "item_id": "B08TM8HWQQ",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 25,
              "price": "Rs 425.00",
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Organic-Natural-Crunchy-Unsweetened/dp/B071J53T7M/",
              "page_count": 48,
              "reviews": 1053,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "Pintola Organic Peanut Butter (Crunchy) (1kg)",
              "item_id": "B071J53T7M",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 26,
              "price": "Rs 275.00",
              "offer": "Rs 285.00",
              "page": 1,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Creamy-924g/dp/B01N99EUBN/",
              "page_count": 48,
              "reviews": 209,
              "ratings": 4.4,
              "image_count": 5,
              "product_name": "Sundrop Peanut Butter, Creamy, 924g",
              "item_id": "B01N99EUBN",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 27,
              "price": "Rs 399.00",
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Alpino-Natural-Peanut-Butter-Unsweetened/dp/B0714D4Q9D/",
              "page_count": 48,
              "reviews": 1642,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Alpino Natural Peanut Butter Smooth 1 KG | Unsweetened | Made with 100% Roasted Peanuts | 30% Protein | No Added Sugar | No Added Salt | No Hydrogenated Oils | Non GMO | Gluten Free | Vegan",
              "item_id": "B0714D4Q9D",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 28,
              "price": "Rs 300.00",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Creamy-924g/dp/B01KA8P574/",
              "page_count": 48,
              "reviews": 613,
              "ratings": 4.3,
              "image_count": 3,
              "product_name": "Sundrop Peanut Butter, Creamy, 924g",
              "item_id": "B01KA8P574",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 29,
              "price": "Rs 299.00",
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Trubite-Natural-Unsweetened-Protein-Cholesterol/dp/B08JSFH183/",
              "page_count": 48,
              "reviews": 39,
              "ratings": 4.5,
              "image_count": 6,
              "product_name": "Trubite Natural Peanut Butter (Creamy) (1kg) | Unsweetened | 30g Protein | Non GMO | Gluten Free | Cholesterol Free",
              "item_id": "B08JSFH183",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 30,
              "price": null,
              "offer": "Rs 560.00",
              "page": 1,
              "link": "https://www.amazon.in//Butternut-Co-Unsweetened-Peanut-Butter/dp/B077VR467B/",
              "page_count": 48,
              "reviews": 608,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "The Butternut Co. Peanut Butter Unsweetened, Crunchy 1KG (No Added Sugar, Vegan, High Protein, Keto)",
              "item_id": "B077VR467B",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 31,
              "price": null,
              "offer": "Rs 425.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Creamy-Peanut-Butter-Choco/dp/B0776R83TR/",
              "page_count": 48,
              "reviews": 513,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Pintola Choco Spread Peanut Butter (Creamy) (1kg)",
              "item_id": "B0776R83TR",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 32,
              "price": "Rs 299.00",
              "offer": "Rs 320.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Chocolate-Peanut-Butter-Crunchy/dp/B08TWSR47Y/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 4,
              "product_name": "MYFITNESS Chocolate Peanut Butter Crunchy 510g",
              "item_id": "B08TWSR47Y",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 33,
              "price": "Rs 389.00",
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Natural-Peanut-Butter-Unsweetened/dp/B07MP8YT43/",
              "page_count": 48,
              "reviews": 677,
              "ratings": 4.7,
              "image_count": 7,
              "product_name": "MYFITNESS Gold Natural Peanut Butter Smooth 1Kg (Unsweetened)",
              "item_id": "B07MP8YT43",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 34,
              "price": "Rs 359.00",
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//Nutrio-Chocolate-Chocolaty-Roasted-Peanuts/dp/B08DJ9V6M6/",
              "page_count": 48,
              "reviews": 178,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "Nutrio Chocolate Peanut Butter 1kg (Creamy) (Chocolaty Flavor) | Made with Roasted Peanuts, Cocoa Powder & Choco Chips | Vegan",
              "item_id": "B08DJ9V6M6",
              "brand": "nutrio",
              "client": "oetker"
            },
            {
              "order": 35,
              "price": null,
              "offer": "Rs 349.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Classic-Crunchy-Peanut-Butter/dp/B01MYCKSEL/",
              "page_count": 48,
              "reviews": 556,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Pintola Classic Peanut Butter (Crunchy) (1 kg)",
              "item_id": "B01MYCKSEL",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 36,
              "price": "Rs 350.00",
              "offer": "Rs 560.00",
              "page": 1,
              "link": "https://www.amazon.in//Butternut-Co-Unsweetened-Peanut-Butter/dp/B077VQDH9L/",
              "page_count": 48,
              "reviews": 572,
              "ratings": 4.1,
              "image_count": 5,
              "product_name": "The Butternut Co. Peanut Butter Unsweetened, Creamy 1KG (No Added Sugar, Vegan, High Protein, Keto)",
              "item_id": "B077VQDH9L",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 37,
              "price": null,
              "offer": "Rs 500.00",
              "page": 1,
              "link": "https://www.amazon.in//Disano-Natural-Unsweetened-Peanut-Crunchy/dp/B07MD8H6CK/",
              "page_count": 48,
              "reviews": 656,
              "ratings": 4,
              "image_count": 6,
              "product_name": "DiSano All Natural Peanut Butter, Crunchy, 30% Protein, Unsweetened, Gluten Free, 1 Kg",
              "item_id": "B07MD8H6CK",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 38,
              "price": "Rs 310.00",
              "offer": "Rs 320.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Peanut-Butter-Crunchy-510g/dp/B07HB6175L/",
              "page_count": 48,
              "reviews": 695,
              "ratings": 4.6,
              "image_count": 7,
              "product_name": "MYFITNESS Original Peanut Butter Crunchy 510g",
              "item_id": "B07HB6175L",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 39,
              "price": null,
              "offer": "Rs 285.00",
              "page": 1,
              "link": "https://www.amazon.in//Disano-Peanut-Butter-Creamy-Jar/dp/B07JNQ7C4B/",
              "page_count": 48,
              "reviews": 399,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "DiSano Peanut Butter, Creamy, 25% Protein with Vitamins & Minerals, 1 Kg",
              "item_id": "B07JNQ7C4B",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 40,
              "price": null,
              "offer": "Rs 165.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Natural-Creamy-Unsweetened-Non-GMO/dp/B01N9ZNOWQ/",
              "page_count": 48,
              "reviews": 554,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Pintola All Natural Peanut Butter (Creamy) (350g) (Unsweetened, NON-GMO, GLUTEN FREE, VEGAN)",
              "item_id": "B01N9ZNOWQ",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 41,
              "price": "Rs 549.00",
              "offer": "Rs 649.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Chocolate-Peanut-Butter-Crunchy/dp/B08TWTYGCB/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 4,
              "product_name": "MYFITNESS Chocolate Peanut Butter Crunchy 1250g",
              "item_id": "B08TWTYGCB",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 42,
              "price": "Rs 549.00",
              "offer": "Rs 649.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Chocolate-Peanut-Butter-Crispy/dp/B08THTGPN5/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 4,
              "product_name": "MYFITNESS Chocolate Peanut Butter Crispy 1250g",
              "item_id": "B08THTGPN5",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 43,
              "price": "Rs 402.00",
              "offer": "Rs 449.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Natural-Peanut-Butter-Creamy/dp/B07DBCVTB2/",
              "page_count": 48,
              "reviews": 641,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Pintola All Natural Honey Peanut Butter (Creamy) (1kg)",
              "item_id": "B07DBCVTB2",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 44,
              "price": "Rs 595.00",
              "offer": null,
              "page": 1,
              "link": "https://www.amazon.in//Dr-OETKER-FUN-FOODS-Peanut/dp/B07SW291JH/",
              "page_count": 48,
              "reviews": 202,
              "ratings": 4,
              "image_count": 7,
              "product_name": "Dr. OETKER FUN FOODS Peanut Butter Creamy, 2.5 kg",
              "item_id": "B07SW291JH",
              "brand": "dr. oetker fun foods",
              "client": "oetker"
            },
            {
              "order": 45,
              "price": "Rs 399.00",
              "offer": "Rs 499.00",
              "page": 1,
              "link": "https://www.amazon.in//Alpino-Organic-Natural-Unsweetened-Non-GMO/dp/B07VZFC1J5/",
              "page_count": 48,
              "reviews": 72,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Alpino Organic Natural Peanut Butter Crunch 1 KG | Unsweetened | Made with 100% Roasted Organic Peanuts | 30% Protein | No Added Sugar | No Added Salt | No Hydrogenated Oils | Non GMO | Gluten Free | Vegan",
              "item_id": "B07VZFC1J5",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 46,
              "price": "Rs 359.00",
              "offer": "Rs 899.00",
              "page": 1,
              "link": "https://www.amazon.in//Nutrio-Natural-Crunchy-Chocolate-Unsweetened/dp/B08GCB7FTP/",
              "page_count": 48,
              "reviews": 136,
              "ratings": 4.6,
              "image_count": 7,
              "product_name": "Nutrio 100% Natural Peanut Butter (Crunchy + Chocolate Flavour ) (Unsweetened | 500gm+500gm )(Combo Pack/Pack of 2)",
              "item_id": "B08GCB7FTP",
              "brand": "nutrio",
              "client": "oetker"
            },
            {
              "order": 47,
              "price": "Rs 559.00",
              "offer": "Rs 649.00",
              "page": 1,
              "link": "https://www.amazon.in//MYFITNESS-Peanut-Butter-Smooth-1250g/dp/B07H94QV7Y/",
              "page_count": 48,
              "reviews": 1098,
              "ratings": 4.6,
              "image_count": 7,
              "product_name": "MYFITNESS Original Peanut Butter Smooth 1250g",
              "item_id": "B07H94QV7Y",
              "brand": "i love pb",
              "client": "oetker"
            },
            {
              "order": 48,
              "price": "Rs 379.00",
              "offer": "Rs 449.00",
              "page": 1,
              "link": "https://www.amazon.in//Pintola-Natural-Peanut-Butter-Crunchy/dp/B07DBD2DV3/",
              "page_count": 48,
              "reviews": 423,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Pintola All Natural Honey Peanut Butter (Crunchy) (1kg)",
              "item_id": "B07DBD2DV3",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 49,
              "price": "Rs 349.00",
              "offer": "Rs 449.00",
              "page": 2,
              "link": "https://www.amazon.in//Trubite-Natural-Crunchy-Protein-Preservatives/dp/B08K4CHTWL/",
              "page_count": 48,
              "reviews": 4,
              "ratings": 5,
              "image_count": 6,
              "product_name": "Trubite Natural Honey Peanut Butter (Crunchy) (1kg) | 27g Protein | No Added Sugar | No Added Preservatives | Non GMO | Gluten Free",
              "item_id": "B08K4CHTWL",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 50,
              "price": "Rs 425.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Pintola-Crunchy-Peanut-Butter-Choco/dp/B07L96WDWJ/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 4.5,
              "image_count": 3,
              "product_name": "Pintola Crunchy Peanut Butter, Choco, 1kg",
              "item_id": "B07L96WDWJ",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 51,
              "price": "Rs 352.00",
              "offer": "Rs 900.00",
              "page": 2,
              "link": "https://www.amazon.in//Skippy-Peanut-Butter-Super-Chunky/dp/B00LPE9470/",
              "page_count": 48,
              "reviews": 45,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "SKIPPY Super Chunk Peanut Butter, 462 g",
              "item_id": "B00LPE9470",
              "brand": "skippy",
              "client": "oetker"
            },
            {
              "order": 52,
              "price": "Rs 259.00",
              "offer": "\nRs 284.00",
              "page": 2,
              "link": "https://www.amazon.in//Funfoods-Peanutbutter-Creamy-925g/dp/B079GXPZ41/",
              "page_count": 48,
              "reviews": 20,
              "ratings": 4.3,
              "image_count": 1,
              "product_name": "Funfoods Peanutbutter Creamy, 925g",
              "item_id": "B079GXPZ41",
              "brand": "funfoods",
              "client": "oetker"
            },
            {
              "order": 53,
              "price": null,
              "offer": "Rs 285.00",
              "page": 2,
              "link": "https://www.amazon.in//Disano-Peanut-Butter-Crunchy-Jar/dp/B07LCPZCBC/",
              "page_count": 48,
              "reviews": 269,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Disano Peanut butter crunchy , 1kg",
              "item_id": "B07LCPZCBC",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 54,
              "price": "Rs 356.00",
              "offer": "Rs 379.00",
              "page": 2,
              "link": "https://www.amazon.in//Alpino-Smooth-Peanut-Butter-1kg/dp/B071VGCT41/",
              "page_count": 48,
              "reviews": 525,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Alpino Classic Peanut Butter Smooth 1 KG | Made with Roasted Peanuts | 25% Protein | Non GMO | Gluten Free | Vegan",
              "item_id": "B071VGCT41",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 55,
              "price": "Rs 399.00",
              "offer": "Rs 499.00",
              "page": 2,
              "link": "https://www.amazon.in//Vegan-Natural-Packaging-Unsweetened-Non-GMO/dp/B08GHMCR11/",
              "page_count": 48,
              "reviews": 8,
              "ratings": 5,
              "image_count": 6,
              "product_name": "The Vegan Co.'s All Natural Peanut Butter (Creamy)(Glass Packaging) (Unsweetened, Non-GMO, Gluten Free, Vegan) (1000G)",
              "item_id": "B08GHMCR11",
              "brand": "the vegan co.",
              "client": "oetker"
            },
            {
              "order": 56,
              "price": "Rs 449.00",
              "offer": "Rs 499.00",
              "page": 2,
              "link": "https://www.amazon.in//Cassava-Peanut-Choclate-Protein-Hydrogented/dp/B07WNNJ6FM/",
              "page_count": 48,
              "reviews": 13,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Cassava Chocolate Peanut Butter ,Dark Chocolate , 1kg ( High Protein ,High Fiber )",
              "item_id": "B07WNNJ6FM",
              "brand": "cassava",
              "client": "oetker"
            },
            {
              "order": 57,
              "price": "Rs 425.00",
              "offer": "Rs 550.00",
              "page": 2,
              "link": "https://www.amazon.in//HealthKart-Peanut-Protein-Fortified-Unsweetened/dp/B07FF96DSJ/",
              "page_count": 48,
              "reviews": 248,
              "ratings": 4,
              "image_count": 6,
              "product_name": "Nouriza High-Protein Natural Peanut Butter with Added Whey Protein, Unsweetened, Crunchy, 1 Kg",
              "item_id": "B07FF96DSJ",
              "brand": "nouriza",
              "client": "oetker"
            },
            {
              "order": 58,
              "price": "Rs 399.00",
              "offer": "Rs 425.00",
              "page": 2,
              "link": "https://www.amazon.in//Bagrrys-Natural-Peanut-Crunchy-Unsweetened/dp/B07MLRXMZX/",
              "page_count": 48,
              "reviews": 74,
              "ratings": 4.4,
              "image_count": 5,
              "product_name": "Bagrry's Natural Peanut Butter, Crunchy, 1 KG, Unsweetened",
              "item_id": "B07MLRXMZX",
              "brand": "bagrry's",
              "client": "oetker"
            },
            {
              "order": 59,
              "price": "Rs 249.00",
              "offer": "Rs 349.00",
              "page": 2,
              "link": "https://www.amazon.in//Well-Nuts-Chocolate-Peanut-Butter/dp/B08HLV8W1B/",
              "page_count": 48,
              "reviews": 5,
              "ratings": 3.6,
              "image_count": 6,
              "product_name": "Well Nuts Dark Chocolate Peanut Butter Powder 200 G",
              "item_id": "B08HLV8W1B",
              "brand": "well nuts",
              "client": "oetker"
            },
            {
              "order": 60,
              "price": "Rs 180.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Pintola-Natural-Peanut-Butter-Crunchy/dp/B07L9FQQL5/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 3,
              "product_name": "Pintola All Natural Peanut Butter, Extra Crunchy, 350g",
              "item_id": "B07L9FQQL5",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 61,
              "price": "Rs 399.00",
              "offer": "Rs 425.00",
              "page": 2,
              "link": "https://www.amazon.in//Bagrrys-Natural-Peanut-Butter-Unsweetened/dp/B07MBZ6JLG/",
              "page_count": 48,
              "reviews": 61,
              "ratings": 4.3,
              "image_count": 5,
              "product_name": "Bagrry's Natural Peanut Butter, Creamy, 1 KG, Unsweetened",
              "item_id": "B07MBZ6JLG",
              "brand": "bagrry's",
              "client": "oetker"
            },
            {
              "order": 62,
              "price": "Rs 399.00",
              "offer": "Rs 499.00",
              "page": 2,
              "link": "https://www.amazon.in//Alpino-Organic-Natural-Unsweetened-Non-GMO/dp/B07W53R9LM/",
              "page_count": 48,
              "reviews": 84,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Alpino Organic Natural Peanut Butter Smooth 1 KG | Unsweetened | Made with 100% Roasted Organic Peanuts | 30% Protein | No Added Sugar | No Added Salt | No Hydrogenated Oils | Non GMO | Gluten Free | Vegan",
              "item_id": "B07W53R9LM",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 63,
              "price": "Rs 399.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//VEEBA-Natural-Peanut-Butter-Crunchy/dp/B08Q1CL2NY/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "VEEBA Natural Peanut Butter Crunchy - Unsweetened,  (100% Peanuts) Jar,  1000 g",
              "item_id": "B08Q1CL2NY",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 64,
              "price": null,
              "offer": "Rs 185.00",
              "page": 2,
              "link": "https://www.amazon.in//Pintola-Choco-Peanut-Butter-Creamy/dp/B018GH5NMI/",
              "page_count": 48,
              "reviews": 210,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Pintola Choco Spread Peanut Butter (Creamy) (350g)",
              "item_id": "B018GH5NMI",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 65,
              "price": "Rs 299.00",
              "offer": "Rs 349.00",
              "page": 2,
              "link": "https://www.amazon.in//Trubite-Classic-Protein-Cholesterol-Delightful/dp/B08K4B3S1B/",
              "page_count": 48,
              "reviews": 19,
              "ratings": 4.7,
              "image_count": 6,
              "product_name": "Trubite Classic Peanut Butter (Creamy) (1kg) | 26g Protein | Cholesterol Free | Indian Recipe | Delightful Taste",
              "item_id": "B08K4B3S1B",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 66,
              "price": "Rs 549.00",
              "offer": "Rs 640.00",
              "page": 2,
              "link": "https://www.amazon.in//MYFITNESS-Crunchy-Peanut-Butter-510g/dp/B08DNQG113/",
              "page_count": 48,
              "reviews": 3,
              "ratings": 4.8,
              "image_count": 6,
              "product_name": "MYFITNESS Crunchy Peanut Butter 510g (Pack of 2)",
              "item_id": "B08DNQG113",
              "brand": "myfitness",
              "client": "oetker"
            },
            {
              "order": 67,
              "price": "Rs 379.00",
              "offer": "Rs 499.00",
              "page": 2,
              "link": "https://www.amazon.in//Cassava-Frutti-Peanut-Butter-hydrogenated/dp/B08HNLGVTX/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 5,
              "image_count": 4,
              "product_name": "Cassava Tutti Frutti Peanut Butter 1 KG (Vegan , No hydrogenated/Palm Oil)",
              "item_id": "B08HNLGVTX",
              "brand": "cassava",
              "client": "oetker"
            },
            {
              "order": 68,
              "price": "Rs 350.00",
              "offer": "Rs 560.00",
              "page": 2,
              "link": "https://www.amazon.in//Butternut-Co-Classic-Jaggery-Separation/dp/B082NRR8YT/",
              "page_count": 48,
              "reviews": 35,
              "ratings": 4.2,
              "image_count": 5,
              "product_name": "The Butternut Co. Peanut Butter Classic with Jaggery, Creamy 1KG (No Oil Separation^, Vegan, High Protein,No Stir)",
              "item_id": "B082NRR8YT",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 69,
              "price": "Rs 285.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Veeba-Creamy-Peanut-Butter-1kg/dp/B077FTZ3WY/",
              "page_count": 48,
              "reviews": 19,
              "ratings": 3.9,
              "image_count": 4,
              "product_name": "Veeba Creamy Peanut Butter, 925g",
              "item_id": "B077FTZ3WY",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 70,
              "price": "Rs 160.00",
              "offer": "Rs 185.00",
              "page": 2,
              "link": "https://www.amazon.in//Trubite-Chocolate-Goodness-Cholesterol-Antioxidant/dp/B08HP5VGXL/",
              "page_count": 48,
              "reviews": 23,
              "ratings": 5,
              "image_count": 6,
              "product_name": "Trubite Chocolate Peanut Butter (Crunchy) | High in Protein | Goodness of Dark Chocolate | No Cholesterol | Rich in Antioxidant (350g)",
              "item_id": "B08HP5VGXL",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 71,
              "price": "Rs 449.00",
              "offer": "Rs 599.00",
              "page": 2,
              "link": "https://www.amazon.in//Alpino-Unsweetened-Natural-Peanut-Butter/dp/B07FY7XGPK/",
              "page_count": 48,
              "reviews": 105,
              "ratings": 3.6,
              "image_count": 6,
              "product_name": "Alpino Natural Peanut Butter Powder 400 G (Unsweetened / 15 G Protein / 3 G Fat / Gluten Free / Non-GMO / Vegan)",
              "item_id": "B07FY7XGPK",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 72,
              "price": null,
              "offer": "Rs 490.00",
              "page": 2,
              "link": "https://www.amazon.in//Skippy-Reduced-Peanut-Crunchy-Product/dp/B01M4RS3FJ/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 3.7,
              "image_count": 7,
              "product_name": "SKIPPY Super Chunk Reduced Fat Peanut Butter Pet Bottle, 462 g",
              "item_id": "B01M4RS3FJ",
              "brand": "skippy",
              "client": "oetker"
            },
            {
              "order": 73,
              "price": null,
              "offer": "Rs 275.00",
              "page": 2,
              "link": "https://www.amazon.in//Natural-Unsweetened-Creamy-Peanut-Butter/dp/B078WSTNVX/",
              "page_count": 48,
              "reviews": 12,
              "ratings": 4.4,
              "image_count": 6,
              "product_name": "Happy Jars 100% Natural Unsweetened Creamy Peanut Butter | Smooth Consistency | Gluten-Free | Vegan | No Oil | No Sugar | No Preservatives | No Cholesterol (290g)",
              "item_id": "B078WSTNVX",
              "brand": "happy jars",
              "client": "oetker"
            },
            {
              "order": 74,
              "price": "Rs 349.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Alpino-Peanut-Butter-Crunch-1kg/dp/B077RY4CBB/",
              "page_count": 48,
              "reviews": 474,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Alpino Peanut Butter Crunch, 1kg",
              "item_id": "B077RY4CBB",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 75,
              "price": "Rs 375.00",
              "offer": "Rs 440.00",
              "page": 2,
              "link": "https://www.amazon.in//HealthKart-Peanut-Butter-Unsweetened-Crunchy/dp/B07DFHKPPP/",
              "page_count": 48,
              "reviews": 206,
              "ratings": 3.9,
              "image_count": 5,
              "product_name": "Nouriza 100% Natural Peanut Butter, Unsweetened (Crunchy, 1 Kg)",
              "item_id": "B07DFHKPPP",
              "brand": "nouriza",
              "client": "oetker"
            },
            {
              "order": 76,
              "price": "Rs 189.00",
              "offer": "Rs 199.00",
              "page": 2,
              "link": "https://www.amazon.in//Ketofy-Choco-Peanut-Butter-Ultra/dp/B07XBGKW9C/",
              "page_count": 48,
              "reviews": 89,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Ketofy - Choco Peanut Butter (200g) | Ultra Low Carb Peanut Butter",
              "item_id": "B07XBGKW9C",
              "brand": "ketofy",
              "client": "oetker"
            },
            {
              "order": 77,
              "price": null,
              "offer": "Rs 250.00",
              "page": 2,
              "link": "https://www.amazon.in//Natural-Jaggery-Crunchy-Peanut-Butter/dp/B078WSXNZ8/",
              "page_count": 48,
              "reviews": 31,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Happy Jars Jaggery Crunchy Peanut Butter | Crunchy |Gluten-Free| Vegan| No Oil | No Sugar | No Preservatives | No Cholesterol (290g)",
              "item_id": "B078WSXNZ8",
              "brand": "happy jars",
              "client": "oetker"
            },
            {
              "order": 78,
              "price": null,
              "offer": "Rs 980.00",
              "page": 2,
              "link": "https://www.amazon.in//Pintola-Natural-Creamy-Unsweetened-Non-GMO/dp/B0728JDVNC/",
              "page_count": 48,
              "reviews": 226,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Pintola All Natural Peanut Butter (Creamy) (2.5 kg) (Unsweetened, Non-GMO, Gluten Free, Vegan)",
              "item_id": "B0728JDVNC",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 79,
              "price": null,
              "offer": "Rs 400.00",
              "page": 2,
              "link": "https://www.amazon.in//Happy-Jars-Butter-Variety-Pack/dp/B08HLNJN95/",
              "page_count": 48,
              "reviews": 4,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Happy Jars Nut Butter Variety Pack - Try 6 Flavours of Peanut and Almond Butter, 60g Each",
              "item_id": "B08HLNJN95",
              "brand": "happy jars",
              "client": "oetker"
            },
            {
              "order": 80,
              "price": "Rs 221.00",
              "offer": "Rs 349.00",
              "page": 2,
              "link": "https://www.amazon.in//Joy-Layer-Natural-Gluten-Free-Unsweetened/dp/B08NGG1PY9/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 5,
              "image_count": 7,
              "product_name": "Joy Layer Natural Peanut Butter Powder 200gm ( 16g Protein / 3g Fat / Low Carb / Vegan / Gluten-Free / Non-GMO / Unsweetened )",
              "item_id": "B08NGG1PY9",
              "brand": "joy layer",
              "client": "oetker"
            },
            {
              "order": 81,
              "price": "Rs 149.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Funfoods-Peanut-Butter-Creamy-340g/dp/B00O8X9RVI/",
              "page_count": 48,
              "reviews": 15,
              "ratings": 4.3,
              "image_count": 1,
              "product_name": "Funfoods Peanut Butter Creamy, 340g+60g Extra",
              "item_id": "B00O8X9RVI",
              "brand": "funfoods",
              "client": "oetker"
            },
            {
              "order": 82,
              "price": null,
              "offer": "Rs 520.00",
              "page": 2,
              "link": "https://www.amazon.in//Butternut-Co-Chocolate-Crunchy-Refined/dp/B08C7T3KG4/",
              "page_count": 48,
              "reviews": 15,
              "ratings": 3.9,
              "image_count": 5,
              "product_name": "The Butternut Co. Peanut Butter Chocolate, Crunchy 925 gm (No Refined Sugar, High Protein, 100% Natural)",
              "item_id": "B08C7T3KG4",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 83,
              "price": "Rs 155.00",
              "offer": "Rs 225.00",
              "page": 2,
              "link": "https://www.amazon.in//Solimo-Natural-Unsweetened-Peanut-Butter/dp/B07KZ6LY11/",
              "page_count": 48,
              "reviews": 146,
              "ratings": 3.7,
              "image_count": 7,
              "product_name": "Amazon Brand - Solimo Natural Unsweetened Peanut Butter , Creamy , 500 g",
              "item_id": "B07KZ6LY11",
              "brand": "amazon brand - solimo",
              "client": "oetker"
            },
            {
              "order": 84,
              "price": "Rs 387.00",
              "offer": "Rs 425.00",
              "page": 2,
              "link": "https://www.amazon.in//Just-Natural-Peanut-Butter-Hydrogenated/dp/B07D6LQMJ1/",
              "page_count": 48,
              "reviews": 76,
              "ratings": 4,
              "image_count": 4,
              "product_name": "Just Nuts All Natural Creamy Peanut Butter 1 kg (Unsweetened, Non-GMO, Gluten Free, Vegan)",
              "item_id": "B07D6LQMJ1",
              "brand": "just nuts",
              "client": "oetker"
            },
            {
              "order": 85,
              "price": "Rs 165.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Pintola-Natural-Creamy-Peanut-Butter/dp/B07L9D2NB6/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 4.2,
              "image_count": 4,
              "product_name": "Pintola All Natural Creamy Peanut Butter, 350g",
              "item_id": "B07L9D2NB6",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 86,
              "price": null,
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Nouriza-Chocolate-Peanut-Butter-Spread/dp/B07QCX8XDF/",
              "page_count": 48,
              "reviews": 70,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Nouriza Dark Chocolate Peanut Butter Spread with added Whey Protein, 1 Kg",
              "item_id": null,
              "brand": "nouriza",
              "client": "oetker"
            },
            {
              "order": 87,
              "price": "Rs 399.00",
              "offer": "Rs 449.00",
              "page": 2,
              "link": "https://www.amazon.in//Muscle-Nectar-Natural-Unsweetened-Unsalted/dp/B07MFJNMCP/",
              "page_count": 48,
              "reviews": 25,
              "ratings": 3.8,
              "image_count": 3,
              "product_name": "Muscle Nectar (MN) All Natural Amino Peanut Butter (Unsweetened & Unsalted) | 100% Dry Roasted Peanuts | 100% Non-GMO | Gluten-Free | Vegan, (Creamy, 1kg)",
              "item_id": "B07MFJNMCP",
              "brand": "muscle nectar",
              "client": "oetker"
            },
            {
              "order": 88,
              "price": "Rs 172.00",
              "offer": "Rs 249.00",
              "page": 2,
              "link": "https://www.amazon.in//Alpino-Organic-Natural-Peanut-Non-GMO/dp/B07W52ZPKV/",
              "page_count": 48,
              "reviews": 67,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Alpino Organic Natural Peanut Butter Crunch 400 G | Unsweetened | Made with 100% Roasted Organic Peanuts | 30% Protein | No Added Sugar | No Added Salt | No Hydrogenated Oils | Non GMO | Gluten Free | Vegan",
              "item_id": "B07W52ZPKV",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 89,
              "price": "Rs 428.00",
              "offer": "Rs 699.00",
              "page": 2,
              "link": "https://www.amazon.in//Hersheys-Reeses-Miniature-Peanut-Butter/dp/B077PRCNDB/",
              "page_count": 48,
              "reviews": 19,
              "ratings": 4.2,
              "image_count": 1,
              "product_name": "Hershey's Reese's Miniature Peanut Butter Cups, 150g",
              "item_id": "B077PRCNDB",
              "brand": "hershey's",
              "client": "oetker"
            },
            {
              "order": 90,
              "price": "Rs 299.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Oxie-Nutrition-Chocolate-Peanut-Butter/dp/B08SWM51GB/",
              "page_count": 48,
              "reviews": 21,
              "ratings": 4.9,
              "image_count": 4,
              "product_name": "Oxie Nutrition Chocolate Peanut Butter, 500g",
              "item_id": "B08SWM51GB",
              "brand": "oxie nutrition",
              "client": "oetker"
            },
            {
              "order": 91,
              "price": "Rs 275.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//Natural-Unsweetened-Crunchy-Peanut-Butter/dp/B078WT37ZR/",
              "page_count": 48,
              "reviews": 22,
              "ratings": 4,
              "image_count": 6,
              "product_name": "Happy Jars 100% Natural Unsweetened Crunchy Peanut Butter | Extra Crunchy | Gluten-Free | Vegan | No Oil | No Sugar | No Preservatives | No Cholesterol (290g)",
              "item_id": "B078WT37ZR",
              "brand": "happy jars",
              "client": "oetker"
            },
            {
              "order": 92,
              "price": "Rs 30.00",
              "offer": null,
              "page": 2,
              "link": "https://www.amazon.in//SDPB-Creamy-Sachet-32g-Free/dp/B079H34CNC/",
              "page_count": 48,
              "reviews": 6,
              "ratings": 3.9,
              "image_count": 1,
              "product_name": "Sundrop Peanut Butter Creamy Sachet, 32g (Buy 2 Get 1 Free)",
              "item_id": "B079H34CNC",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 93,
              "price": "Rs 265.00",
              "offer": "\nRs 440.00",
              "page": 2,
              "link": "https://www.amazon.in//Solimo-Natural-Unsweetened-Peanut-Crunchy/dp/B07KYT4W2L/",
              "page_count": 48,
              "reviews": 136,
              "ratings": 3.2,
              "image_count": 7,
              "product_name": "Amazon Brand - Solimo Natural Unsweetened Peanut Butter , Crunchy , 1 kg",
              "item_id": "B07KYT4W2L",
              "brand": "amazon brand - solimo",
              "client": "oetker"
            },
            {
              "order": 94,
              "price": null,
              "offer": "Rs 285.00",
              "page": 2,
              "link": "https://www.amazon.in//Disano-Peanut-Butter-Creamy-Jar/dp/B07LCNJJP1/",
              "page_count": 48,
              "reviews": 107,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Disano Peanut butter creamy , 1 kg",
              "item_id": "B07LCNJJP1",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 95,
              "price": null,
              "offer": "Rs 675.00",
              "page": 2,
              "link": "https://www.amazon.in//Butternut-Co-Unsweetened-Organic-Peanut/dp/B07HZ9SVM1/",
              "page_count": 48,
              "reviews": 107,
              "ratings": 4.3,
              "image_count": 5,
              "product_name": "The Butternut Co. Peanut Butter Organic Unsweetened, 1KG (No Added Sugar, Vegan, High Protein, Keto)",
              "item_id": "B07HZ9SVM1",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 96,
              "price": null,
              "offer": "Rs 349.00",
              "page": 2,
              "link": "https://www.amazon.in//PINTOLA-Classic-Peanut-Butter-Creamy/dp/B01MRAE1TT/",
              "page_count": 48,
              "reviews": 343,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Pintola Classic Peanut Butter (Creamy) (1 kg)",
              "item_id": "B01MRAE1TT",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 97,
              "price": "Rs 165.00",
              "offer": "Rs 185.00",
              "page": 3,
              "link": "https://www.amazon.in//Butternut-Co-Chocolate-Refined-Protein/dp/B07WX13XVC/",
              "page_count": 48,
              "reviews": 67,
              "ratings": 3.9,
              "image_count": 7,
              "product_name": "The Butternut Co. Peanut Butter Chocolate, 340 gm (No Refined Sugar, High Protein, 100% Natural)",
              "item_id": "B07WX13XVC",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 98,
              "price": "Rs 299.00",
              "offer": "Rs 515.00",
              "page": 3,
              "link": "https://www.amazon.in//Swasthum-Mettle-Classic-Regular-Non-GMO/dp/B08HWXJ5BV/",
              "page_count": 48,
              "reviews": 30,
              "ratings": 4.2,
              "image_count": 6,
              "product_name": "Swasthum Mettle Peanut Butter Tasty Classic (Regular) 907g (Gluten Free / Non-GMO, Vegan)",
              "item_id": "B08HWXJ5BV",
              "brand": "swasthum",
              "client": "oetker"
            },
            {
              "order": 99,
              "price": "Rs 265.00",
              "offer": "\nRs 440.00",
              "page": 3,
              "link": "https://www.amazon.in//Solimo-Peanut-Butter-Crunchy/dp/B07KZ5LH3H/",
              "page_count": 48,
              "reviews": 74,
              "ratings": 3.7,
              "image_count": 6,
              "product_name": "Amazon Brand - Solimo Peanut Butter , Crunchy , 1 kg",
              "item_id": "B07KZ5LH3H",
              "brand": "amazon brand - solimo",
              "client": "oetker"
            },
            {
              "order": 100,
              "price": "Rs 359.00",
              "offer": "Rs 499.00",
              "page": 3,
              "link": "https://www.amazon.in//Nutrio-Natural-Unsweetened-Crunchy-Roasted/dp/B08CXL1H1S/",
              "page_count": 48,
              "reviews": 72,
              "ratings": 4.5,
              "image_count": 7,
              "product_name": "Nutrio 100% Natural Peanut Butter Unsweetened 1KG (Crunchy) || Made with 100% Roasted Peanuts | No Added Sugar | No Added Salt | No Added Oils | Vegan (1kg)",
              "item_id": "B08CXL1H1S",
              "brand": "nutrio",
              "client": "oetker"
            },
            {
              "order": 101,
              "price": "Rs 184.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//VEEBA-Choco-Peanut-Spread-Crunchy/dp/B08Q1FH8SD/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "VEEBA Choco Peanut Spread Crunchy Jar,  340 g",
              "item_id": "B08Q1FH8SD",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 102,
              "price": "Rs 285.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Veeba-Crunchy-Peanut-Butter-1kg/dp/B077G3ST32/",
              "page_count": 48,
              "reviews": 17,
              "ratings": 3.9,
              "image_count": 4,
              "product_name": "Veeba Crunchy Peanut Butter, 925g",
              "item_id": "B077G3ST32",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 103,
              "price": "Rs 225.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Honey-Crunchy/dp/B00PLKT8EI/",
              "page_count": 48,
              "reviews": 128,
              "ratings": 4.3,
              "image_count": 1,
              "product_name": "Sundrop Peanut Butter Honey Roast Crunchy, 462g",
              "item_id": "B00PLKT8EI",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 104,
              "price": "Rs 430.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//AMOREARTH-Natural-Jaggery-Artificial-Preservatives/dp/B07K33SWRN/",
              "page_count": 48,
              "reviews": 36,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Two Brothers Organic Farms Amorearth Jaggery Peanut Butter , Stoneground 300 GMS",
              "item_id": "B07K33SWRN",
              "brand": "two brothers organic farms",
              "client": "oetker"
            },
            {
              "order": 105,
              "price": "Rs 225.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Sundrop-Peanut-Spread-Honey-Creamy/dp/B00PLKSZ4C/",
              "page_count": 48,
              "reviews": 98,
              "ratings": 4.2,
              "image_count": 1,
              "product_name": "Sundrop Peanut Spread Honey Roast Creamy, 462g",
              "item_id": "B00PLKSZ4C",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 106,
              "price": "Rs 234.00",
              "offer": "\nRs 249.00",
              "page": 3,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Added-Creamy/dp/B07D1GMMGH/",
              "page_count": 48,
              "reviews": 69,
              "ratings": 4.2,
              "image_count": 5,
              "product_name": "Sundrop Peanut Butter No Added Sugar and Salt Creamy Jar, 924g",
              "item_id": "B07D1GMMGH",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 107,
              "price": null,
              "offer": "Rs 155.00",
              "page": 3,
              "link": "https://www.amazon.in//Pintola-Crunchy-Peanut-Butter-Grams/dp/B018GH5O86/",
              "page_count": 48,
              "reviews": 168,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Pintola Classic Peanut Butter (Crunchy) (350g)",
              "item_id": "B018GH5O86",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 108,
              "price": "Rs 449.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Pintola-Natural-Peanut-Butter-Crunchy/dp/B07L9F51SH/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 4,
              "image_count": 4,
              "product_name": "Pintola All Natural Honey Peanut Butter, Crunchy, 1kg",
              "item_id": "B07L9F51SH",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 109,
              "price": "Rs 349.00",
              "offer": "Rs 429.00",
              "page": 3,
              "link": "https://www.amazon.in//Poustik-Natural-Crunchy-Unsweetened-Non-GMO/dp/B08D7HTTCY/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 5,
              "image_count": 5,
              "product_name": "Poustik Natural Crunchy Peanut Butter (Unsweetened / Gluten Free / Non-GMO / Vegan) (Natural Crunchy 1KG)",
              "item_id": "B08D7HTTCY",
              "brand": "poustik",
              "client": "oetker"
            },
            {
              "order": 110,
              "price": "Rs 251.00",
              "offer": "Rs 349.00",
              "page": 3,
              "link": "https://www.amazon.in//Joy-Layer-Chocolate-Protein-Gluten-Free/dp/B08NF7FV6M/",
              "page_count": 48,
              "reviews": 4,
              "ratings": 5,
              "image_count": 7,
              "product_name": "Joy Layer Dark Chocolate Peanut Butter Powder 200gm ( 14g Protein / Low Fat / Low Carb / Vegan / Gluten-Free / Non-GMO )",
              "item_id": "B08NF7FV6M",
              "brand": "joy layer",
              "client": "oetker"
            },
            {
              "order": 111,
              "price": "Rs 350.00",
              "offer": "Rs 400.00",
              "page": 3,
              "link": "https://www.amazon.in//Urban-Platter-Natural-Creamy-Unsweetened/dp/B07KHX5TQ9/",
              "page_count": 48,
              "reviews": 33,
              "ratings": 3.7,
              "image_count": 6,
              "product_name": "Urban Platter Natural Creamy Peanut Butter, 1kg / 35.2oz [Unsweetened, No Added Oil, Vegan]",
              "item_id": "B07KHX5TQ9",
              "brand": "urban platter",
              "client": "oetker"
            },
            {
              "order": 112,
              "price": "Rs 165.00",
              "offer": "Rs 185.00",
              "page": 3,
              "link": "https://www.amazon.in//Butternut-Co-Unsweetened-Crunchy-Friendly/dp/B07V73F93B/",
              "page_count": 48,
              "reviews": 31,
              "ratings": 3.9,
              "image_count": 5,
              "product_name": "The Butternut Co. Peanut Butter Unsweetened No Stir, Crunchy 340 gm (No Oil Separation^, No Added Sugar, High Protein)",
              "item_id": "B07V73F93B",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 113,
              "price": "Rs 169.00",
              "offer": "Rs 175.00",
              "page": 3,
              "link": "https://www.amazon.in//Kissan-Peanut-Butter-Bottle-350/dp/B08L8HR5FD/",
              "page_count": 48,
              "reviews": 5,
              "ratings": 3.6,
              "image_count": 7,
              "product_name": "Kissan Peanut Butter Bottle, 350 g",
              "item_id": "B08L8HR5FD",
              "brand": "kissan",
              "client": "oetker"
            },
            {
              "order": 114,
              "price": "Rs 379.00",
              "offer": "Rs 499.00",
              "page": 3,
              "link": "https://www.amazon.in//Cassava-Coconut-Creamy-Peanut-hydrogenated/dp/B08HS5KWJ2/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 5,
              "image_count": 4,
              "product_name": "Cassava Coconut Creamy Peanut Butter 1 KG ( Vegan , No hydrogenated Oil , No Added Sugar )",
              "item_id": "B08HS5KWJ2",
              "brand": "cassava",
              "client": "oetker"
            },
            {
              "order": 115,
              "price": "Rs 257.00",
              "offer": "Rs 349.00",
              "page": 3,
              "link": "https://www.amazon.in//Happilo-Super-Crunchy-Peanut-Butter/dp/B07F1GPGPD/",
              "page_count": 48,
              "reviews": 69,
              "ratings": 4,
              "image_count": 6,
              "product_name": "Happilo Super Crunchy Peanut Butter (High Protein, Non-GMO, Gluten Free, Vegan) Bottle, 1 kg",
              "item_id": "B07F1GPGPD",
              "brand": "happilo",
              "client": "oetker"
            },
            {
              "order": 116,
              "price": null,
              "offer": "Rs 475.00",
              "page": 3,
              "link": "https://www.amazon.in//Happy-Jars-Natural-Creamy-Protein/dp/B08HKJB8JN/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "Happy Jars 100% Natural Creamy Peanut Butter Combo, 2* 290g Jars (No Sugar, High Protein, Vegan)",
              "item_id": "B08HKJB8JN",
              "brand": "happy jars",
              "client": "oetker"
            },
            {
              "order": 117,
              "price": "Rs 350.00",
              "offer": "Rs 400.00",
              "page": 3,
              "link": "https://www.amazon.in//Urban-Platter-Natural-Crunchy-Unsweetened/dp/B07KGGT9C5/",
              "page_count": 48,
              "reviews": 27,
              "ratings": 3.7,
              "image_count": 6,
              "product_name": "Urban Platter Natural Crunchy Peanut Butter, 1kg / 35.2oz [Unsweetened, No Added Oil, Vegan]",
              "item_id": "B07KGGT9C5",
              "brand": "urban platter",
              "client": "oetker"
            },
            {
              "order": 118,
              "price": "Rs 249.00",
              "offer": "Rs 250.00",
              "page": 3,
              "link": "https://www.amazon.in//Nutrition-Natural-Peanut-Butter_Cinnamon-Salted/dp/B0862BCGY9/",
              "page_count": 48,
              "reviews": 7,
              "ratings": 4.3,
              "image_count": 7,
              "product_name": "Vegan Nutrition Natural Peanut Butter_Cinnamon Salted (1) 500 grams",
              "item_id": "B0862BCGY9",
              "brand": "generic",
              "client": "oetker"
            },
            {
              "order": 119,
              "price": "Rs 369.00",
              "offer": "Rs 499.00",
              "page": 3,
              "link": "https://www.amazon.in//Cassava-Natural-Unsweetened-Protein-Cholesterol/dp/B07WQR7447/",
              "page_count": 48,
              "reviews": 3,
              "ratings": 3.2,
              "image_count": 6,
              "product_name": "Cassava Peanut Butter All Natural Creamy , 1kg (Unsweetened High Protein High Fiber Zero Cholesterol)",
              "item_id": "B07WQR7447",
              "brand": "cassava",
              "client": "oetker"
            },
            {
              "order": 120,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Nouriza-Chocolate-Peanut-Vitamins-Minerals/dp/B08C9FBFQ3/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "Nouriza Dark Chocolate Peanut Butter Spread with Added Vitamins and Minerals, 100 gm",
              "item_id": null,
              "brand": "nouriza",
              "client": "oetker"
            },
            {
              "order": 121,
              "price": "Rs 149.00",
              "offer": "Rs 200.00",
              "page": 3,
              "link": "https://www.amazon.in//Cassava-Crunchy-Chocolate-Peanut-Protein/dp/B08TTSV9QS/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 4,
              "product_name": "Cassava Crunchy Chocolate Peanut Butter , Chocolate , 300G ( High Protein ,High Fiber )",
              "item_id": "B08TTSV9QS",
              "brand": "cassava",
              "client": "oetker"
            },
            {
              "order": 122,
              "price": "Rs 425.00",
              "offer": "Rs 550.00",
              "page": 3,
              "link": "https://www.amazon.in//Nouriza-Chocolate-Peanut-Vitamin-Mineral/dp/B07Q8FBH7N/",
              "page_count": 48,
              "reviews": 140,
              "ratings": 4,
              "image_count": 7,
              "product_name": "Nouriza Dark Chocolate Peanut Butter with Added Vitamin & Minerals, 1 kg",
              "item_id": "B07Q8FBH7N",
              "brand": "nouriza",
              "client": "oetker"
            },
            {
              "order": 123,
              "price": "Rs 399.00",
              "offer": "Rs 475.00",
              "page": 3,
              "link": "https://www.amazon.in//Alpino-Coconut-Roasted-Goodness-Gluten-Free/dp/B08CKR54GT/",
              "page_count": 48,
              "reviews": 55,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Alpino Coconut Peanut Butter Smooth 1 KG | India’s 1st Coconut Peanut Butter | Made with Roasted Peanuts & Goodness of Coconut | 22% Protein | Non GMO | Gluten Free | Vegan",
              "item_id": "B08CKR54GT",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 124,
              "price": "Rs 185.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Pintola-Natural-Peanut-Butter-Creamy/dp/B07L9BZ6M8/",
              "page_count": 48,
              "reviews": 2,
              "ratings": 4.5,
              "image_count": 4,
              "product_name": "Pintola All Natural Honey Peanut Butter, Creamy, 350g",
              "item_id": "B07L9BZ6M8",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 125,
              "price": "Rs 150.00",
              "offer": "\nRs 200.00",
              "page": 3,
              "link": "https://www.amazon.in//Solimo-Peanut-Butter-Creamy-500/dp/B07KZ6VG56/",
              "page_count": 48,
              "reviews": 84,
              "ratings": 3.9,
              "image_count": 7,
              "product_name": "Amazon Brand - Solimo Peanut Butter , Creamy , 500 g",
              "item_id": "B07KZ6VG56",
              "brand": "amazon brand - solimo",
              "client": "oetker"
            },
            {
              "order": 126,
              "price": null,
              "offer": "Rs 175.00",
              "page": 3,
              "link": "https://www.amazon.in//Disano-Peanut-Butter-Creamy-Bottle/dp/B07TJJ5XCK/",
              "page_count": 48,
              "reviews": 12,
              "ratings": 3.9,
              "image_count": 2,
              "product_name": "Disano Choco Peanut Butter Creamy Bottle, 350 g",
              "item_id": "B07TJJ5XCK",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 127,
              "price": null,
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Earthnut-Peanut-Butter-Chocolate-Non-GMO/dp/B0899RDTCN/",
              "page_count": 48,
              "reviews": 35,
              "ratings": 4.6,
              "image_count": 6,
              "product_name": "Earthnut Peanut Butter Chocolate 1Kg (Gluten Free / Non-GMO / Vegan)",
              "item_id": "B0899RDTCN",
              "brand": "earthnut",
              "client": "oetker"
            },
            {
              "order": 128,
              "price": "Rs 324.00",
              "offer": "Rs 325.00",
              "page": 3,
              "link": "https://www.amazon.in//Skippy-Peanut-Butter-Creamy-340g/dp/B004YBNF80/",
              "page_count": 48,
              "reviews": 4,
              "ratings": 4.8,
              "image_count": 7,
              "product_name": "Skippy Peanut Butter Creamy, 340G",
              "item_id": "B004YBNF80",
              "brand": "skippy",
              "client": "oetker"
            },
            {
              "order": 129,
              "price": "Rs 215.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Crunchy-462g/dp/B00PLKSULA/",
              "page_count": 48,
              "reviews": 106,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Sundrop Peanut Butter Crunchy, 462g +46g Free = 508g",
              "item_id": "B00PLKSULA",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 130,
              "price": "Rs 375.00",
              "offer": "Rs 440.00",
              "page": 3,
              "link": "https://www.amazon.in//HealthKart-Peanut-Fortified-Vitamins-Minerals/dp/B07FF6L969/",
              "page_count": 48,
              "reviews": 155,
              "ratings": 3.9,
              "image_count": 4,
              "product_name": "Nouriza Natual Peanut Butter with Added Vitamins & Minerals, Unsweetened, (Creamy, 1 Kg)",
              "item_id": "B07FF6L969",
              "brand": "nouriza",
              "client": "oetker"
            },
            {
              "order": 131,
              "price": null,
              "offer": "Rs 499.00",
              "page": 3,
              "link": "https://www.amazon.in//Flex-Protein-Smooth-Peanut-Natural/dp/B07XP21K5T/",
              "page_count": 48,
              "reviews": 23,
              "ratings": 4,
              "image_count": 7,
              "product_name": "Flex Protein Smooth Peanut Butter Natural with No Added Salt, Sugar Or Oils (1 kg)",
              "item_id": "B07XP21K5T",
              "brand": "flex protein",
              "client": "oetker"
            },
            {
              "order": 132,
              "price": "Rs 470.00",
              "offer": "Rs 599.00",
              "page": 3,
              "link": "https://www.amazon.in//Skippy-Peanut-Butter-Extra-Crunchy/dp/B0107F42PQ/",
              "page_count": 48,
              "reviews": 34,
              "ratings": 4.2,
              "image_count": 5,
              "product_name": "Skippy Peanut Butter Extra Crunchy Super Chunk, 462G",
              "item_id": "B0107F42PQ",
              "brand": "skippy",
              "client": "oetker"
            },
            {
              "order": 133,
              "price": "Rs 349.00",
              "offer": "Rs 475.00",
              "page": 3,
              "link": "https://www.amazon.in//Montagne-Natural-Peanut-Crunchy-Unsweetened/dp/B08CZN2CWN/",
              "page_count": 48,
              "reviews": 12,
              "ratings": 3.7,
              "image_count": 3,
              "product_name": "Montagne Natural Unsweetened Crunchy Peanut Butter 1 KG - Made with 100% Roasted Peanuts | No Added Sugar & Salt | No Hydrogenated Oils",
              "item_id": "B08CZN2CWN",
              "brand": "montagne",
              "client": "oetker"
            },
            {
              "order": 134,
              "price": null,
              "offer": "Rs 250.00",
              "page": 3,
              "link": "https://www.amazon.in//Happy-Jars-Chocolate-Peanut-Butter/dp/B07NRRF37S/",
              "page_count": 48,
              "reviews": 10,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Happy Jars Dark Chocolate Peanut Butter | 80% Peanuts | Dark Chocolate | Gluten-Free | Vegan | No Oil | Low Sugar | No Preservatives (290g)",
              "item_id": "B07NRRF37S",
              "brand": "happy jars",
              "client": "oetker"
            },
            {
              "order": 135,
              "price": "Rs 299.00",
              "offer": "Rs 349.00",
              "page": 3,
              "link": "https://www.amazon.in//Trubite-Classic-Crunchy-Cholesterol-Delightful/dp/B08K499HJ3/",
              "page_count": 48,
              "reviews": 7,
              "ratings": 4.6,
              "image_count": 6,
              "product_name": "Trubite Classic Peanut Butter (Crunchy) (1kg) | 26g Protein | Cholesterol Free | Indian Recipe | Delightful Taste",
              "item_id": "B08K499HJ3",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 136,
              "price": "Rs 150.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Jelly-Grape/dp/B07F46YSCL/",
              "page_count": 48,
              "reviews": 26,
              "ratings": 4.1,
              "image_count": 5,
              "product_name": "Sundrop Peanut Butter with Jelly Jar, Grape, 340g",
              "item_id": "B07F46YSCL",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 137,
              "price": "Rs 149.25",
              "offer": "Rs 199.00",
              "page": 3,
              "link": "https://www.amazon.in//Mustin-Chocolate-Peanut-Butter-Jar/dp/B08L656J74/",
              "page_count": 48,
              "reviews": 7,
              "ratings": 4.5,
              "image_count": 4,
              "product_name": "Mustin Chocolate Peanut Butter Jar, 340 g",
              "item_id": "B08L656J74",
              "brand": "mustin",
              "client": "oetker"
            },
            {
              "order": 138,
              "price": "Rs 138.00",
              "offer": "Rs 164.00",
              "page": 3,
              "link": "https://www.amazon.in//VEEBA-Natural-Peanut-Butter-Crunchy/dp/B08Q17KMDB/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "VEEBA Natural Peanut Butter Crunchy - Unsweetened, (100% Peanuts) Jar,  340 g",
              "item_id": "B08Q17KMDB",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 139,
              "price": "Rs 430.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Brothers-Organic-Amorearth-Crunchy-Stoneground/dp/B08CDYT957/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 5,
              "image_count": 6,
              "product_name": "Two Brothers Organic Farms Amorearth Peanut Butter, Crunchy Jaggery, Stoneground 300 GMS",
              "item_id": "B08CDYT957",
              "brand": "two brothers organic farms",
              "client": "oetker"
            },
            {
              "order": 140,
              "price": "Rs 979.00",
              "offer": "Rs 1,298.00",
              "page": 3,
              "link": "https://www.amazon.in//MYFITNESS-Peanut-Butter-Smooth-1-25kg/dp/B08DNS45D3/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 5,
              "image_count": 6,
              "product_name": "MYFITNESS Peanut Butter Smooth 2.5kg (1.25kg X Pack of 2)",
              "item_id": "B08DNS45D3",
              "brand": "myfitness",
              "client": "oetker"
            },
            {
              "order": 141,
              "price": "Rs 50.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Honey-Crunchy/dp/B079H7X7SR/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "Sundrop Peanut Butter Honey Roast Crunchy, 100g",
              "item_id": "B079H7X7SR",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 142,
              "price": "Rs 405.00",
              "offer": "Rs 499.00",
              "page": 3,
              "link": "https://www.amazon.in//Cassava-Natural-Crunchy-Unsweetened-Cholesterol/dp/B07VXNKQ1L/",
              "page_count": 48,
              "reviews": 15,
              "ratings": 4.1,
              "image_count": 7,
              "product_name": "Cassava Peanut Butter All Natural Crunchy 1kg (Unsweetened High Protein High Fiber Zero Cholesterol Gulten Free)",
              "item_id": "B07VXNKQ1L",
              "brand": "cassava",
              "client": "oetker"
            },
            {
              "order": 143,
              "price": "Rs 480.00",
              "offer": null,
              "page": 3,
              "link": "https://www.amazon.in//Nutriwish-Peanut-Butter-Chocolate-Bottle/dp/B08JQY5F12/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 3,
              "product_name": "Nutriwish Peanut Butter with Dark Chocolate Bottle, 1000 g",
              "item_id": "B08JQY5F12",
              "brand": "nutriwish",
              "client": "oetker"
            },
            {
              "order": 144,
              "price": "Rs 199.00",
              "offer": "Rs 230.00",
              "page": 3,
              "link": "https://www.amazon.in//Jus-Amazin-Organic-Peanut-Butter/dp/B07QG2C41L/",
              "page_count": 48,
              "reviews": 42,
              "ratings": 3.8,
              "image_count": 7,
              "product_name": "Jus Amazin Creamy Organic Peanut Butter – Choco Delight (200g) | 26% Protein | Plant-Based Nutrition | Zero Chemicals | Vegan | Dairy-Free | 100% Organic Ingredients",
              "item_id": "B07QG2C41L",
              "brand": "jus' amazin",
              "client": "oetker"
            },
            {
              "order": 145,
              "price": "Rs 399.00",
              "offer": "Rs 490.00",
              "page": 4,
              "link": "https://www.amazon.in//Skippy-Natural-Peanut-Butter-Creamy/dp/B00LQGMZDW/",
              "page_count": 48,
              "reviews": 5,
              "ratings": 4,
              "image_count": 3,
              "product_name": "Skippy Natural Peanut Butter Creamy Less Sodium & Sugar",
              "item_id": "B00LQGMZDW",
              "brand": "skippy",
              "client": "oetker"
            },
            {
              "order": 146,
              "price": "Rs 285.00",
              "offer": "Rs 340.00",
              "page": 4,
              "link": "https://www.amazon.in//Just-Nuts-Natural-Crunchy-Unsweetened/dp/B07L5LZFH7/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 5,
              "image_count": 6,
              "product_name": "Just Nuts All Natural Crunchy Peanut Butter 340 gm (Pack of 2) (Unsweetened, Non-GMO, Gluten Free, Vegan)",
              "item_id": "B07L5LZFH7",
              "brand": "just nuts",
              "client": "oetker"
            },
            {
              "order": 147,
              "price": "Rs 350.00",
              "offer": "Rs 370.00",
              "page": 4,
              "link": "https://www.amazon.in//Butternut-Co-Chocolate-Refined-Protein/dp/B0897NKZ2P/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 4.7,
              "image_count": 6,
              "product_name": "The Butternut Co. Peanut Butter Chocolate, 340 gm (No Refined Sugar, High Protein, 100% Natural) - Pack of 2",
              "item_id": "B0897NKZ2P",
              "brand": "the butternut co.",
              "client": "oetker"
            },
            {
              "order": 148,
              "price": "Rs 350.00",
              "offer": "Rs 430.00",
              "page": 4,
              "link": "https://www.amazon.in//FITTER-FRESH-Crunchy-Peanut-Jaggery/dp/B085XVZ77Q/",
              "page_count": 48,
              "reviews": 12,
              "ratings": 5,
              "image_count": 7,
              "product_name": "FITTER FRESH Gluten-Free Vegan Natural Crunchy Peanut Butter with Organic Jaggery - 300 gm",
              "item_id": "B085XVZ77Q",
              "brand": "fitter fresh",
              "client": "oetker"
            },
            {
              "order": 149,
              "price": "Rs 189.00",
              "offer": "Rs 199.00",
              "page": 4,
              "link": "https://www.amazon.in//Ketofy-Peanut-Butter-200g-Ultra/dp/B07R72JTX9/",
              "page_count": 48,
              "reviews": 55,
              "ratings": 3.9,
              "image_count": 7,
              "product_name": "Ketofy - Peanut Butter (200g) | Ultra Low Carb Peanut Butter",
              "item_id": "B07R72JTX9",
              "brand": "ketofy",
              "client": "oetker"
            },
            {
              "order": 150,
              "price": "Rs 229.00",
              "offer": "Rs 275.00",
              "page": 4,
              "link": "https://www.amazon.in//Kuliza-Natural-Peanut-Unsweetened-Non-GMO/dp/B08HTVR5Q7/",
              "page_count": 48,
              "reviews": 3,
              "ratings": 5,
              "image_count": 7,
              "product_name": "Kuliza All Natural Peanut Butter Creamy (Unsweetened, Non-GMO, Gluten Free, Vegan) (Creamy, 500 GM)",
              "item_id": "B08HTVR5Q7",
              "brand": "kuliza",
              "client": "oetker"
            },
            {
              "order": 151,
              "price": "Rs 185.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Pintola-Natural-Peanut-Butter-Crunchy/dp/B07L9DCG17/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 4.6,
              "image_count": 4,
              "product_name": "Pintola All Natural Honey Peanut Butter, Crunchy, 350g",
              "item_id": "B07L9DCG17",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 152,
              "price": "Rs 475.00",
              "offer": "Rs 550.00",
              "page": 4,
              "link": "https://www.amazon.in//Jus-Amazin-Cashew-Butter-Unsweetened/dp/B08HD668NV/",
              "page_count": 48,
              "reviews": 3,
              "ratings": 5,
              "image_count": 7,
              "product_name": "Jus Amazin Cashew Butter - All Natural, Unsweetened, High Protein, Vegan, Cholesterol Free, Dairy Free, 100% Natural, Plant-Based Protein, 200 GMS",
              "item_id": "B08HD668NV",
              "brand": "jus' amazin",
              "client": "oetker"
            },
            {
              "order": 153,
              "price": "Rs 369.00",
              "offer": "Rs 499.00",
              "page": 4,
              "link": "https://www.amazon.in//Kuliza-Chocolate-Protein-Cholesterol-Chocolate-Crunchy/dp/B08HVKTRFN/",
              "page_count": 48,
              "reviews": 4,
              "ratings": 4.2,
              "image_count": 7,
              "product_name": "Kuliza Chocolate Spread High Protein Peanut Butter ( Zero Cholesterol, Dairy Free , Vegan) (Chocolate-Crunchy, 1 KG)",
              "item_id": "B08HVKTRFN",
              "brand": "kuliza",
              "client": "oetker"
            },
            {
              "order": 154,
              "price": "Rs 184.00",
              "offer": "Rs 195.00",
              "page": 4,
              "link": "https://www.amazon.in//JUS-AMAZIN-Organic-Peanut-Natural/dp/B07QRQ1H7Q/",
              "page_count": 48,
              "reviews": 48,
              "ratings": 4.3,
              "image_count": 6,
              "product_name": "Jus Amazin Creamy Organic Peanut Butter - Unsweetened (200g) | 31% Protein | Plant-Based Nutrition | 100% Organic Peanuts | Zero Additives | Vegan | Dairy Free | 100% Organic Ingredients",
              "item_id": "B07QRQ1H7Q",
              "brand": "jus' amazin",
              "client": "oetker"
            },
            {
              "order": 155,
              "price": "Rs 224.00",
              "offer": "\nRs 249.00",
              "page": 4,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Percent-Natural/dp/B07D1MYTHB/",
              "page_count": 48,
              "reviews": 20,
              "ratings": 3.4,
              "image_count": 4,
              "product_name": "Agro Tech Foods Sundrop Peanut Butter 100% Natural-Creamy Jar 924 g",
              "item_id": "B07D1MYTHB",
              "brand": "agro tech foods",
              "client": "oetker"
            },
            {
              "order": 156,
              "price": "Rs 172.00",
              "offer": "Rs 249.00",
              "page": 4,
              "link": "https://www.amazon.in//Alpino-Organic-Natural-Unsweetened-Non-GMO/dp/B084GNSKSD/",
              "page_count": 48,
              "reviews": 5,
              "ratings": 3.7,
              "image_count": 6,
              "product_name": "Alpino Organic Natural Peanut Butter Smooth 400 G | Unsweetened | Made with 100% Roasted Organic Peanuts | 30% Protein | No Added Sugar | No Added Salt | No Hydrogenated Oils | Non GMO | Gluten Free | Vegan",
              "item_id": "B084GNSKSD",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 157,
              "price": "Rs 570.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//VEEBA-Peanut-Butter-Crunchy-Jar/dp/B08Q1HNMBF/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 3,
              "product_name": "VEEBA Peanut Butter Crunchy Jar, 2 X 925 g",
              "item_id": "B08Q1HNMBF",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 158,
              "price": "Rs 209.00",
              "offer": "Rs 229.00",
              "page": 4,
              "link": "https://www.amazon.in//Boncell-Protein-Classic-Sweetened-Gluten-Free/dp/B08P7L1FLT/",
              "page_count": 48,
              "reviews": 4,
              "ratings": 5,
              "image_count": 7,
              "product_name": "Boncell High Protein Classic Peanut Butter Creamy 450 G | Sweetened | 100% Non-GMO | Gluten-Free | Vegan",
              "item_id": "B08P7L1FLT",
              "brand": "boncell",
              "client": "oetker"
            },
            {
              "order": 159,
              "price": "Rs 249.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//GoDelicious-Chocolate-Peanut-Butter-Gluten-Free/dp/B08PYT9HLT/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 5,
              "image_count": 6,
              "product_name": "GoDelicious Chocolate Peanut Butter Creamy 500G | Gluten-Free | Vegan",
              "item_id": "B08PYT9HLT",
              "brand": "godelicious",
              "client": "oetker"
            },
            {
              "order": 160,
              "price": "Rs 199.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Pintola-Organic-Natural-Creamy-Peanut/dp/B07L94G78T/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 5,
              "image_count": 3,
              "product_name": "Pintola Organic All Natural Creamy Peanut Butter, 350g",
              "item_id": "B07L94G78T",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 161,
              "price": "Rs 350.00",
              "offer": "Rs 389.00",
              "page": 4,
              "link": "https://www.amazon.in//Natural-Peanut-Crunchy-Vegetarian-Friendly/dp/B08MFJ3SDV/",
              "page_count": 48,
              "reviews": 17,
              "ratings": 5,
              "image_count": 6,
              "product_name": "Maska Natural Peanut Butter Crunchy 500 GMS (Gluten Free / Vegan/ Vegetarian/ Keto Friendly)?",
              "item_id": "B08MFJ3SDV",
              "brand": "maska",
              "client": "oetker"
            },
            {
              "order": 162,
              "price": "Rs 155.00",
              "offer": "Rs 185.00",
              "page": 4,
              "link": "https://www.amazon.in//Trubite-Natural-Peanut-Protein-Preservatives/dp/B08HQPN6HK/",
              "page_count": 48,
              "reviews": 3,
              "ratings": 3.4,
              "image_count": 6,
              "product_name": "Trubite Natural Honey Peanut Butter (Creamy) (350g) | 27g Protein | No Added Sugar | No Added Preservatives | Non GMO | Gluten Free",
              "item_id": "B08HQPN6HK",
              "brand": "trubite",
              "client": "oetker"
            },
            {
              "order": 163,
              "price": "Rs 225.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Honey-Creamy/dp/B01CHV23KY/",
              "page_count": 48,
              "reviews": 21,
              "ratings": 4.5,
              "image_count": 6,
              "product_name": "Sundrop Peanut Butter Honey Roast Creamy, 462g",
              "item_id": "B01CHV23KY",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 164,
              "price": "Rs 223.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//VEEBA-Breakfast-Eggless-Mayonnaise-Natural/dp/B08Q1HR7K7/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 4,
              "image_count": 2,
              "product_name": "VEEBA Breakfast - Eggless Mayonnaise, 250g & Natural Peanut Butter Crunchy - 340g Combo",
              "item_id": "B08Q1HR7K7",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 165,
              "price": null,
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//American-Garden-Peanut-Butter-Creamy/dp/B00L2ZK1CO/",
              "page_count": 48,
              "reviews": 77,
              "ratings": 4.2,
              "image_count": 5,
              "product_name": "American Garden U.S. Peanut Butter Creamy, 510g",
              "item_id": "B00L2ZK1CO",
              "brand": "american garden",
              "client": "oetker"
            },
            {
              "order": 166,
              "price": "Rs 415.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Skippy-Reduced-Creamy-Peanut-Butter/dp/B003ZWPD66/",
              "page_count": 48,
              "reviews": 7,
              "ratings": 4.2,
              "image_count": 4,
              "product_name": "Skippy Reduced Fat Creamy Peanut Butter, 462g",
              "item_id": "B003ZWPD66",
              "brand": "skippy",
              "client": "oetker"
            },
            {
              "order": 167,
              "price": "Rs 449.00",
              "offer": "Rs 500.00",
              "page": 4,
              "link": "https://www.amazon.in//Skippy-Extra-Crunchy-Peanut-Butter/dp/B07KF5TBLL/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 5,
              "image_count": 2,
              "product_name": "Skippy Extra Crunchy Peanut Butter 462gm",
              "item_id": "B07KF5TBLL",
              "brand": "skippy",
              "client": "oetker"
            },
            {
              "order": 168,
              "price": "Rs 158.00",
              "offer": "Rs 184.00",
              "page": 4,
              "link": "https://www.amazon.in//VEEBA-Peanut-Butter-Crunchy-Peanuts/dp/B08Q19RGVB/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "VEEBA Honey Peanut Butter Crunchy, (Only Honey & Peanuts) Jar,  340 g",
              "item_id": "B08Q19RGVB",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 169,
              "price": "Rs 374.00",
              "offer": "Rs 499.00",
              "page": 4,
              "link": "https://www.amazon.in//Mustin-Chocolate-Peanut-Butter-1000/dp/B08L64SN7J/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 1.5,
              "image_count": 4,
              "product_name": "Mustin Chocolate Peanut Butter Jar, 1000 g",
              "item_id": "B08L64SN7J",
              "brand": "mustin",
              "client": "oetker"
            },
            {
              "order": 170,
              "price": "Rs 132.00",
              "offer": "Rs 199.00",
              "page": 4,
              "link": "https://www.amazon.in//Happilo-Creamy-Chocolate-Peanut-Butter/dp/B07F15G9TD/",
              "page_count": 48,
              "reviews": 16,
              "ratings": 3.8,
              "image_count": 5,
              "product_name": "Happilo Super Creamy Chocolate Peanut Butter (High Protein, Non-GMO, Gluten Free, Vegan) Bottle, 350 g",
              "item_id": "B07F15G9TD",
              "brand": "happilo",
              "client": "oetker"
            },
            {
              "order": 171,
              "price": "Rs 224.00",
              "offer": "\nRs 249.00",
              "page": 4,
              "link": "https://www.amazon.in//Sundrop-Peanut-Percent-Natural-Crunchy/dp/B07D1M5BHC/",
              "page_count": 48,
              "reviews": 34,
              "ratings": 3.2,
              "image_count": 4,
              "product_name": "Agro Tech Foods Sundrop Peanut Butter 100% Natural-Crunchy Jar 924 g",
              "item_id": "B07D1M5BHC",
              "brand": "agro tech foods",
              "client": "oetker"
            },
            {
              "order": 172,
              "price": "Rs 114.00",
              "offer": "Rs 159.00",
              "page": 4,
              "link": "https://www.amazon.in//Happilo-Super-Creamy-Peanut-Butter/dp/B07F1GPGPF/",
              "page_count": 48,
              "reviews": 38,
              "ratings": 4,
              "image_count": 5,
              "product_name": "Happilo Super Creamy Peanut Butter (High Protein, Non-GMO, Gluten Free, Vegan) Bottle, 350 g",
              "item_id": "B07F1GPGPF",
              "brand": "happilo",
              "client": "oetker"
            },
            {
              "order": 173,
              "price": "Rs 300.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Peepal-Farm-Peanut-Butter-Pack/dp/B08BJZTV6R/",
              "page_count": 48,
              "reviews": 11,
              "ratings": 4.8,
              "image_count": 7,
              "product_name": "Peepal Farm Peanut Butter Pack of 2 (250g Each)",
              "item_id": "B08BJZTV6R",
              "brand": "peepal farm",
              "client": "oetker"
            },
            {
              "order": 174,
              "price": "Rs 445.00",
              "offer": "Rs 549.00",
              "page": 4,
              "link": "https://www.amazon.in//Krepito-Chocolate-Creamy-Peanut-Butter/dp/B08PYLS2YQ/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "Krepito Chocolate Creamy Peanut Butter 1kg",
              "item_id": "B08PYLS2YQ",
              "brand": "krepito",
              "client": "oetker"
            },
            {
              "order": 175,
              "price": "Rs 399.00",
              "offer": "Rs 499.00",
              "page": 4,
              "link": "https://www.amazon.in//Vegan-Natural-Crunchy-Packaging-Unsweetened/dp/B08GH73HRD/",
              "page_count": 48,
              "reviews": 18,
              "ratings": 4.6,
              "image_count": 6,
              "product_name": "The Vegan Co.'s All Natural Peanut Butter (Crunchy)(Glass Packaging) (Unsweetened, Non-GMO, Gluten Free, Vegan) (1000G)",
              "item_id": "B08GH73HRD",
              "brand": "the vegan co.",
              "client": "oetker"
            },
            {
              "order": 176,
              "price": "Rs 738.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Alpino-Chocolate-Bigmuscles-Nutrition-Strength/dp/B08QNQ79N4/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "Alpino Chocolate Peanut Butter Smooth, 1 kg and Bigmuscles Nutrition Omega-3 Fish Oil Triple Strength, 60 Softgels",
              "item_id": "B08QNQ79N4",
              "brand": "alpino",
              "client": "oetker"
            },
            {
              "order": 177,
              "price": "Rs 229.00",
              "offer": "Rs 249.00",
              "page": 4,
              "link": "https://www.amazon.in//Boncell-Chocolate-Sweetened-Non-GMO-Gluten-Free/dp/B08PZC6XQM/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "Boncell Chocolate Peanut Butter Creamy 450 G | Sweetened |100% Non-GMO | Gluten-Free | Vegan",
              "item_id": "B08PZC6XQM",
              "brand": "boncell",
              "client": "oetker"
            },
            {
              "order": 178,
              "price": null,
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Earthnut-Natural-Peanut-Unsweetened-Non-GMO/dp/B0899LS1V7/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "Earthnut Natural Peanut Butter Creamy 1 KG (Unsweetened / Gluten Free / Non-GMO / Vegan)",
              "item_id": "B0899LS1V7",
              "brand": "earthnut",
              "client": "oetker"
            },
            {
              "order": 179,
              "price": "Rs 435.00",
              "offer": "Rs 549.00",
              "page": 4,
              "link": "https://www.amazon.in//Krepito-Classic-Creamy-Peanut-Butter/dp/B08Q7KD4B7/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 6,
              "product_name": "Krepito Classic Creamy Peanut Butter 1kg",
              "item_id": "B08Q7KD4B7",
              "brand": "krepito",
              "client": "oetker"
            },
            {
              "order": 180,
              "price": "Rs 403.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Crunchy-Protein-Vitamins-Minerals-Disano/dp/B08HM8V1L1/",
              "page_count": 48,
              "reviews": 1,
              "ratings": 4.7,
              "image_count": 7,
              "product_name": "DiSano Peanut Butter, Crunchy, 25% Protein with Vitamins & Minerals, 1 Kg + Disano High in Protein and Fibre Oats Pouch, 1 kg",
              "item_id": "B08HM8V1L1",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 181,
              "price": "Rs 639.00",
              "offer": "Rs 1,034.00",
              "page": 4,
              "link": "https://www.amazon.in//MYFITNESS-Peanut-Butter-Chocolate-Instant/dp/B08RJG8J79/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "MYFITNESS Peanut Butter Chocolate 1250g & Coffee Cup Pro Instant Coffee Powder 30g Combo Pack| Combo Offer",
              "item_id": "B08RJG8J79",
              "brand": "myfitness",
              "client": "oetker"
            },
            {
              "order": 182,
              "price": "Rs 100.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Sundrop-Peanut-Butter-Honey-Creamy/dp/B00PLKTPIW/",
              "page_count": 48,
              "reviews": 35,
              "ratings": 4.4,
              "image_count": 7,
              "product_name": "Sundrop Peanut Butter Honey Roast Creamy, 200g",
              "item_id": "B00PLKTPIW",
              "brand": "sundrop",
              "client": "oetker"
            },
            {
              "order": 183,
              "price": "Rs 149.00",
              "offer": "Rs 199.00",
              "page": 4,
              "link": "https://www.amazon.in//Tastylo-Natural-Peanut-Butter-unsweetened/dp/B08P4ML4VL/",
              "page_count": 48,
              "reviews": 6,
              "ratings": 5,
              "image_count": 5,
              "product_name": "Tastylo Natural Peanut Butter 350g ( unsweetened)",
              "item_id": "B08P4ML4VL",
              "brand": "tastylo",
              "client": "oetker"
            },
            {
              "order": 184,
              "price": "Rs 411.00",
              "offer": "Rs 698.00",
              "page": 4,
              "link": "https://www.amazon.in//Joy-Layer-Chocolate-Protein-Gluten-Free/dp/B08P8Z4QH7/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "Joy Layer Dark Chocolate Peanut Butter Powder 400gm | Pack of 2 ( 14g Protein / Low Fat / Low Carb / Vegan / Gluten-Free / Non-GMO )",
              "item_id": "B08P8Z4QH7",
              "brand": "joy layer",
              "client": "oetker"
            },
            {
              "order": 185,
              "price": "Rs 399.00",
              "offer": "Rs 525.00",
              "page": 4,
              "link": "https://www.amazon.in//MUF-Natural-UNSWEETENED-Protein-PRESERVATIVES/dp/B08LP1VNGY/",
              "page_count": 48,
              "reviews": 7,
              "ratings": 3.7,
              "image_count": 7,
              "product_name": "MUF Peanut Butter 1kg (All Natural UNSWEETENED) Creamy, | HIGH Protein | NO Sugar | NO PRESERVATIVES",
              "item_id": "B08LP1VNGY",
              "brand": "muf",
              "client": "oetker"
            },
            {
              "order": 186,
              "price": "Rs 835.00",
              "offer": "Rs 990.00",
              "page": 4,
              "link": "https://www.amazon.in//PINTOLA-Choco-Peanut-Butter-Creamy/dp/B08M41ZMMD/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 5,
              "product_name": "PINTOLA Choco Peanut Butter (Creamy) 2.5Kg",
              "item_id": "B08M41ZMMD",
              "brand": "pintola",
              "client": "oetker"
            },
            {
              "order": 187,
              "price": "Rs 305.00",
              "offer": "Rs 449.00",
              "page": 4,
              "link": "https://www.amazon.in//MUCHMORE-NUTRITION-Natural-Non-GMO-Supplements/dp/B08KW2S4CB/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "MUCHMORE NUTRITION All Natural Tutti Frutti Peanut Butter 1kg (India's 1st Tutti Frutti Peanut Butter / Gluten Free / Non-GMO / Vegan) Pre Workout Supplements | Weight Loss/Gainer Product",
              "item_id": "B08KW2S4CB",
              "brand": "muchmore nutrition",
              "client": "oetker"
            },
            {
              "order": 188,
              "price": "Rs 140.00",
              "offer": "Rs 154.00",
              "page": 4,
              "link": "https://www.amazon.in//Veeba-Creamy-Peanut-Butter-340g/dp/B07DCLVFT9/",
              "page_count": 48,
              "reviews": 4,
              "ratings": 3.9,
              "image_count": 7,
              "product_name": "Veeba Peanut Butter Creamy, 340g",
              "item_id": "B07DCLVFT9",
              "brand": "veeba",
              "client": "oetker"
            },
            {
              "order": 189,
              "price": null,
              "offer": "Rs 230.00",
              "page": 4,
              "link": "https://www.amazon.in//Disano-Peanut-Butter-Crunchy-350/dp/B07MNKFCPG/",
              "page_count": 48,
              "reviews": 25,
              "ratings": 4.1,
              "image_count": 6,
              "product_name": "DiSano Peanut Butter, Crunchy, 25% Protein with Vitamins & Minerals, 350g (2 x 350g)",
              "item_id": "B07MNKFCPG",
              "brand": "disano",
              "client": "oetker"
            },
            {
              "order": 190,
              "price": "Rs 300.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Organics-Ayush-Flax-Chia-Peanut/dp/B08BXM4RTW/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "Future Organics Ayush Natural Flax Seed Chia Seeds Peanut Butter - 160 Grams | Made with 100% Natural Herbal Ingredients",
              "item_id": "B08BXM4RTW",
              "brand": "future organics –eat oragnic! be organic!!",
              "client": "oetker"
            },
            {
              "order": 191,
              "price": null,
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Earthnut-Peanut-Crunchy-Chocolate-Non-GMO/dp/B089CTPZ2L/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 7,
              "product_name": "Earthnut Peanut Butter Combo Crunchy Chocolate (Non-GMO, Gluten Free, Vegan)(500g + 500g) 1 kg",
              "item_id": null,
              "brand": "earthnut",
              "client": "oetker"
            },
            {
              "order": 192,
              "price": "Rs 199.00",
              "offer": null,
              "page": 4,
              "link": "https://www.amazon.in//Mustin-Strawberry-Peanut-Butter-Jar/dp/B08QVVTXD3/",
              "page_count": 48,
              "reviews": 0,
              "ratings": 0,
              "image_count": 5,
              "product_name": "Mustin Strawberry Peanut Butter Jar, 340 g",
              "item_id": "B08QVVTXD3",
              "brand": "mustin",
              "client": "oetker"
            }
          ]
        }
         
        for (let [idx, ds] of  resData.entries())
        {
          self.rows_details.push(ds)
          self.rows_details_full.push(ds)
        }
        self.loader = false
        self.$nextTick(function(){
          self.initDt2()
        })  
      
      }, err => {
        self.loader = false
      });
    },

    changeCustomDate(){
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
    },
    initDt2(){
      let self = this
      $('#myTable2').DataTable({
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                  .appendTo( $(column.footer()).empty() )
                  .on( 'change', function () {
                      var val = $.fn.dataTable.util.escapeRegex(
                          $(this).val()
                      );    
                      column
                          .search( val ? '^'+val+'$' : '', true, false )
                          .draw();
                  } );
              let arr = []    
              let sortedArr = []
              column.data().unique().sort().each( function ( d, j ) {
                var myVal = $(d).text()
                arr.push(myVal)
              } ); 
                
              sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
              for (let [idx, ds] of sortedArr.entries())
              {
                select.append( "<option value='"+ds+"'>"+ds+"</option>" )
              } 
          } );
        }
      });
    }
  }
}

</script>

<style scoped>

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-left: 5px;
  padding-right: 7px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #533a79;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
</style>
